<template>
  <div>
    <div class="lg:px-5">
      <div class="text-xl mb-10 mt-3">
        Preencha os campos para cadastrar o veículo.
      </div>
      <div class="vx-row">
        <div class="px-2 sm:vs-col lg:mx-4 w-full py-8 rounded-lg formVehicle">
          <div v-if="form.somenteAgregado" class="w-full flex flex-wrap">
            <div :class="width33percent">
              <label for="Placa do Agregado" class="vs-select--label"
                >Placa do
                {{
                  this.mascaraAgregado ? this.mascaraAgregado : 'agregado'
                }}</label
              >
              <the-mask
                mask="AAA-#XX#"
                style="text-transform: uppercase"
                id="Placa do Agregado"
                class="vs-inputx vs-input--input normal hasValue w-full"
                v-model="form.placa"
                name="Placa do Agregado"
                :masked="true"
                :state="validateState('Placa do Agregado')"
                :danger="validateClass('Placa do Agregado')"
              />
            </div>

            <div :class="width33percent">
              <span class="vs-select--label">Tipo de Veículo</span>
              <v-select
                :options="tipos"
                name="Tipo Veículo"
                id="Tipo Veículo"
                @input="selecionaTipoFipe()"
                v-model="idTipoFipe"
                v-validate="{ required: true }"
                label="label"
                :state="validateState('Tipo Veículo')"
                :danger="validateClass('Tipo Veículo')"
                :disabled="form.somenteAgregado"
              />
            </div>

            <div
              v-if="isClasse && idTipoFipe.id === 3"
              :class="`${form.isCarroZero ? width50percent : width33percent}`"
            >
              <span class="vs-select--label">Classe</span>
              <v-select
                :options="classes"
                name="Clase"
                id="Clase"
                @input="selecionaClasse()"
                v-model="classe"
                label="label"
              />
            </div>

            <div :class="width33percent">
              <label for="localEstacionamento" class="vs-select--label">
                Você possui garagem para guarda do veículo?
              </label>
              <v-select
                :options="listLocaisEstacionamento"
                name="Local Estacionamento"
                id="Local Estacionamento"
                v-model="form.idTipoEstacionamento"
                v-validate="{ required: true }"
                :reduce="(item) => item.idTipoEstacionamento"
                label="nome"
                :state="validateState('Local Estacionamento')"
                :danger="validateClass('Local Estacionamento')"
              ></v-select>
            </div>

            <div
              v-if="form.somenteAgregado"
              class="w-full flex px-3 justify-end items-center"
            >
              <label
                >Grupo do Veículo:
                <span class="font-bold"> {{ idGrupo.label }}</span></label
              >
              <vs-button
                v-if="
                  placaEncontrada ||
                  !exibirPlaca() ||
                  form.somenteAgregado ||
                  (!placaEncontrada && exibirIptDadosVeiculo) ||
                  (form.habilitaAlterarGrupo && idGrupo && idGrupo.label)
                "
                v-tooltip="'Trocar Grupo do Veículo'"
                radius
                color="success"
                type="flat"
                icon-pack="feather"
                icon="icon-edit"
                class="ml-5"
                @click="mostrarModalGrupos = true"
              />
            </div>
          </div>
          <div v-else class="w-full flex flex-wrap">
            <div
              :class="`${
                form.isCarroZero || !exigirCampoEstacionamentoProposta
                  ? width50percent
                  : width33percent
              }`"
            >
              <div v-if="form.isCarroZero">
                <vs-input
                  v-if="verificaEmpresa()"
                  class="w-full"
                  label="Chassi"
                  v-model="form.chassi"
                  name="Chassi"
                  id="Chassi"
                  v-validate="{ required: true, min: 17, max: 17 }"
                  :state="validateState('Chassi')"
                  :danger="validateClass('Chassi')"
                  @input="
                    chassiToUpperCase(form.chassi),
                      verificaChassiDuplicado(form.chassi),
                      verificaChassiBaseBP()
                  "
                />
              </div>
              <div class="w-full" v-else>
                <label for="Placa" class="vs-select--label">Placa</label>
                <the-mask
                  mask="AAA-#XX#"
                  style="text-transform: uppercase"
                  id="Placa"
                  class="vs-inputx vs-input--input normal hasValue w-full"
                  v-model="form.placa"
                  name="Placa"
                  :masked="true"
                  @input="keymonitorPlaca"
                  v-validate="{ required: true, length: 8 }"
                  :state="validateState('Placa')"
                  :class="validateClass('Placa')"
                />
              </div>
            </div>

            <div
              :class="`${
                form.isCarroZero || !exigirCampoEstacionamentoProposta
                  ? width50percent
                  : width33percent
              }`"
            >
              <span class="vs-select--label">Tipo de Veículo</span>
              <v-select
                :options="tipos"
                name="Tipo Veículo"
                id="Tipo Veículo"
                @input="selecionaTipoFipe()"
                v-model="idTipoFipe"
                v-validate="{ required: true }"
                label="label"
                :state="validateState('Tipo Veículo')"
                :class="validateClass('Tipo Veículo')"
              />
            </div>

            <div
              v-if="isClasse && idTipoFipe.id === 3"
              :class="`${form.isCarroZero ? width50percent : width33percent}`"
            >
              <span class="vs-select--label">Classe</span>
              <v-select
                :options="classes"
                name="Classe"
                id="Classe"
                @input="selecionaClasse()"
                v-validate="{ required: true }"
                :state="validateState('Classe')"
                :danger="validateClass('Classe')"
                v-model="classe"
                label="label"
              />
            </div>

            <vs-popup
              class="holamundo"
              title="Data de saída da nota fiscal inválida"
              :active.sync="modalInfoDataSaidaNf"
              @close="modalInfoDataSaidaNf = false"
            >
              A data de saída da nota físcal é inválida, a saída do veículo deve
              ter no máximo {{ diasZeroKM }} dias
              {{ calcularDiasUteisNfVistoria }}.

              <div class="vx-row">
                <div class="vx-col w-full text-right">
                  <vs-button
                    @click="modalInfoDataSaidaNf = false"
                    type="gradient"
                    color="warning"
                    class="mt-5"
                  >
                    <feather-icon
                      class="text-white"
                      icon="CheckIcon"
                      svgClasses="h-4 w-4"
                    ></feather-icon>
                    Entendi
                  </vs-button>
                </div>
              </div>
            </vs-popup>

            <div v-if="form.isCarroZero" :class="width50percent">
              <vs-input
                v-if="!exibirPlaca() && verificaEmpresa()"
                class="w-full"
                label="Data de saída da NF"
                v-mask="'##/##/####'"
                v-model="form.dataNf"
                @keyup.native="validarDataSaidaNf"
                name="Data de saída da NF"
                id="dataSaidaNF"
                v-validate="'date_format:dd/MM/yyyy'"
                :state="validateState('Data de saída da NF')"
                :danger="validateClass('Data de saída da NF')"
              />
            </div>

            <div
              v-if="
                exigirCampoEstacionamentoProposta &&
                (!form.isCarroZero || formCompleto)
              "
              :class="`${form.isCarroZero ? width50percent : width33percent}`"
            >
              <label for="localEstacionamento" class="vs-select--label">
                Você possui garagem para guarda do veículo?
              </label>
              <v-select
                :options="listLocaisEstacionamento"
                name="Local Estacionamento"
                id="Local Estacionamento"
                v-model="form.idTipoEstacionamento"
                v-validate="{ required: true }"
                :reduce="(item) => item.idTipoEstacionamento"
                label="nome"
                :state="validateState('Local Estacionamento')"
                :class="validateClass('Local Estacionamento')"
              ></v-select>
            </div>

            <vs-alert
              color="danger"
              title="Atenção"
              :active="desabilitaPropostaPorTipoVeiculoEstacionamento"
              >Não é possível fazer propostas quando o veículo é do tipo
              motocicleta e o veículo não possui estacionamento
              privado.</vs-alert
            >

            <div class="vs-col w-full">
              <div class="vx-row mt-6 flex justify-end">
                <div
                  v-if="configuracaoPropostaCaminhao"
                  class="flex justify-between w-full lg:w-1/2"
                >
                  <div v-if="permitirCaminhao" class="vx-col mb-2">
                    <vs-checkbox
                      v-model="form.caminhao"
                      :disabled="!form.somenteAgregado"
                    >
                      {{
                        this.mascaraCaminhao ? this.mascaraCaminhao : 'Caminhão'
                      }}
                    </vs-checkbox>
                  </div>

                  <div v-if="permitirImplemento" class="vx-col mb-2">
                    <vs-checkbox :checked="false" v-model="form.implemento">
                      {{
                        this.mascaraImplemento
                          ? this.mascaraImplemento
                          : 'Implemento'
                      }}
                    </vs-checkbox>
                  </div>

                  <div v-if="permitirAgregado" class="vx-col mb-2">
                    <vs-checkbox :checked="false" v-model="form.agregado">
                      {{
                        this.mascaraAgregado ? this.mascaraAgregado : 'Agregado'
                      }}
                    </vs-checkbox>
                  </div>
                </div>
                <!-- v-if="form.somenteAgregado" -->
                <div
                  v-if="
                    placaEncontrada ||
                    !exibirPlaca() ||
                    form.somenteAgregado ||
                    (!placaEncontrada && exibirIptDadosVeiculo) ||
                    (form.habilitaAlterarGrupo && idGrupo && idGrupo.label)
                  "
                  class="w-full flex gap-5 px-3 justify-end sm:w-1/2 items-center"
                >
                  <label
                    >Grupo do Veículo:
                    <span class="font-bold"> {{ idGrupo.label }}</span></label
                  >
                  <vs-button
                    v-tooltip="'Trocar Grupo do Veículo'"
                    radius
                    color="success"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="ml-5"
                    @click="mostrarModalGrupos = true"
                  ></vs-button>
                  <div v-if="false" class="flex items-center gap-4">
                    <vs-switch
                      color="primary"
                      v-model="form.isTaxiOrApp"
                      class="w-15"
                      :disabled="
                        idTipoFipe && idTipoFipe.id === tipoVeiculo.CAMINHAO
                      "
                    >
                      <span slot="on"></span>
                      <span slot="off"></span>
                    </vs-switch>
                    <span>Táxi/APP</span>
                  </div>
                </div>
              </div>

              <div v-if="!form.somenteAgregado" class="vx-row" style="">
                <div
                  v-if="permitirImplemento || permitirAgregado"
                  class="vx-col sm:w-1/2 mb-2 flex gap-5"
                  style="
                    display: flex;
                    align-items: center;
                    gap: 5px;
                    padding: 17px 10px;
                  "
                >
                  <vs-button
                    v-if="form.implemento"
                    color="primary"
                    type="border"
                    icon="add"
                    @click="
                      abrirModalComplemento(),
                        (tipoConfiguracaoCaminhao = 'implemento')
                    "
                    >Adicionar
                    {{
                      this.mascaraImplemento
                        ? this.mascaraImplemento
                        : 'Implemento'
                    }}</vs-button
                  >
                  <vs-button
                    v-if="form.agregado"
                    color="primary"
                    type="border"
                    icon="add"
                    @click="
                      abrirModalComplemento(),
                        (tipoConfiguracaoCaminhao = 'agregado')
                    "
                    >Adicionar
                    {{
                      this.mascaraAgregado ? this.mascaraAgregado : 'Agregado'
                    }}</vs-button
                  >
                </div>
              </div>
            </div>

            <div
              class="w-1/2 p-3"
              v-if="form.implementos && form.implementos.length > 0"
            >
              <h4 class="mb-3 mt-6">Implementos</h4>
              <hr class="" />
              <vs-list>
                <vs-list-item
                  v-for="(item, indexImplemento) in form.implementos"
                  :key="indexImplemento"
                  :title="definirTituloListaComplementos(item)"
                  :subtitle="definirSubTituloListaComplementos(item)"
                >
                  <div class="vs-row" style="display: flex; gap: 2px">
                    <vs-button
                      color="primary"
                      type="border"
                      icon="edit"
                      @click="
                        editarComplemento({ ...item, index: indexImplemento })
                      "
                    ></vs-button>
                    <vs-button
                      color="danger"
                      type="border"
                      icon="delete"
                      @click="
                        excluirComplemento({ ...item, index: indexImplemento })
                      "
                    ></vs-button>
                  </div>
                </vs-list-item>
              </vs-list>
            </div>

            <div
              class="w-1/2 p-3"
              v-if="form.agregados && form.agregados.length > 0"
            >
              <h4 class="mb-3 mt-6">Agregados</h4>
              <hr class="" />
              <vs-list>
                <vs-list-item
                  v-for="(item, indexAgregado) in form.agregados"
                  :key="indexAgregado"
                  :title="definirTituloListaComplementos(item)"
                  :subtitle="definirSubTituloListaComplementos(item)"
                >
                  <div class="vs-row" style="display: flex; gap: 2px">
                    <vs-button
                      color="primary"
                      type="border"
                      icon="edit"
                      @click="
                        editarComplemento({ ...item, index: indexAgregado })
                      "
                    ></vs-button>
                    <vs-button
                      color="danger"
                      type="border"
                      icon="delete"
                      @click="
                        excluirComplemento({ ...item, index: indexAgregado })
                      "
                    ></vs-button>
                  </div>
                </vs-list-item>
              </vs-list>
            </div>

            <div class="w-full" v-if="placaEncontrada" ref="ModelosEncontrados">
              <vs-alert
                active="true"
                class="bg-secondary text-light mt-3 p-3 mb-3 h-auto"
              >
                <p>
                  {{ dadosPlaca.marcaModelo }} - {{ dadosPlaca.ano }}/{{
                    dadosPlaca.anoModelo
                  }}
                  - <b>Situação</b> {{ dadosPlaca.situacao }}
                </p>
              </vs-alert>
              <div class="p-3 mb-3">
                Encontramos {{ modelosFipeEncontrados.length }} modelo{{
                  modelosFipeEncontrados.length > 1 ? 's' : ''
                }}
                que se assemelha{{
                  modelosFipeEncontrados.length > 1 ? 'm' : ''
                }}
                ao seu veículo, selecione o modelo correto.
              </div>
              <vs-list>
                <vs-list-item
                  v-for="item in modelosFipeEncontrados"
                  :key="item.codigo_fipe"
                  :variant="`${item.selecionado ? 'success' : ''}`"
                  :title="item.texto_modelo"
                  :subtitle="`${item.codigo_fipe}  /  ${item.ano_modelo}-${
                    item.combustivel
                  } ${item.score ? '(score-' + item.score + ')' : ''}`"
                >
                  <vs-radio
                    color="success"
                    v-model="radioSelecionado"
                    :vs-value="item.codigo_fipe"
                    @change="selecionaModelo(item)"
                  ></vs-radio>
                </vs-list-item>

                <vs-list-item title="Nenhum dos modelos acima">
                  <vs-radio
                    color="success"
                    v-model="radioSelecionado"
                    :vs-value="'nenhum'"
                    @change="
                      placaEncontrada = false;
                      btnDisabled2 = false;
                      formCompleto = true;
                      cilindradas = null;
                      idTipoFipe = null;
                    "
                  ></vs-radio>
                </vs-list-item>
              </vs-list>
            </div>
          </div>
          <div v-if="formCompleto || form.somenteAgregado">
            <div class="pl-4 text-lg mb-3 mt-3">
              Preencha manualmente as informações do seu veículo.
            </div>
            <div v-if="form.somenteAgregado" class="w-full flex flex-wrap">
              <div :class="width50percent">
                <label for="">
                  Chassi do
                  {{
                    this.mascaraAgregado ? this.mascaraAgregado : 'agregado'
                  }}</label
                >
                <vs-input
                  class="w-full"
                  name="Chassi do Agregado"
                  v-model="form.chassi"
                  v-validate="{ min: 17, max: 17 }"
                  :state="validateState('Chassi do Agregado')"
                  :danger="validateClass('Chassi do Agregado')"
                  @input="chassiToUpperCase(form.chassi)"
                  @keyup.native="verificaChassiBaseBP"
                />
              </div>
              <div :class="width50percent">
                <label for="">
                  Descrição do
                  {{
                    this.mascaraAgregado ? this.mascaraAgregado : 'agregado'
                  }}</label
                >
                <vs-input
                  class="w-full"
                  name="Descrição do Agregado"
                  v-model="form.descricaoAgregado"
                  v-validate="{ min: 5, required: true }"
                  :state="validateState('Descrição do Agregado')"
                  :danger="validateClass('Descrição do Agregado')"
                />
              </div>
              <div :class="width50percent">
                <label for="">
                  Marca do
                  {{
                    this.mascaraAgregado ? this.mascaraAgregado : 'agregado'
                  }}</label
                >
                <v-select
                  :options="marcaAgregadoImplemento"
                  v-model="form.veiculo.marca"
                  label="label"
                ></v-select>
              </div>
              <div :class="width50percent">
                <vs-input
                  class="w-full"
                  name="Ano Modelo"
                  v-model="form.veiculo.anoModelo"
                  v-mask="'####'"
                  v-validate="{ min: 4, max: 4, required: true }"
                  :state="validateState('Ano Modelo')"
                  :danger="validateClass('Ano Modelo')"
                  label="Ano Modelo"
                />
              </div>
              <div :class="width50percent">
                <label for="">
                  Modelo do
                  {{
                    this.mascaraAgregado ? this.mascaraAgregado : 'agregado'
                  }}</label
                >
                <v-select
                  :options="modeloAgregadoImplemento"
                  v-model="form.veiculo.modelo"
                  label="label"
                ></v-select>
              </div>
              <div :class="width50percent">
                <vs-input
                  class="w-full"
                  label="Ano Fabricação"
                  name="Ano Fabricação"
                  v-model="form.veiculo.anoFabricacao"
                  v-mask="'####'"
                  v-validate="{ min: 4, max: 4, required: true }"
                  :state="validateState('Ano Fabricação')"
                  :danger="validateClass('Ano Fabricação')"
                />
              </div>
            </div>

            <div v-else>
              <div :class="width50percent">
                <label class="vs-select--label">Marca</label>
                <v-select
                  :options="marcas"
                  name="Marca"
                  id="Marca"
                  @input="preencheModelo()"
                  v-model="idMarca"
                  v-validate="{ required: true }"
                  label="text"
                  :state="validateState('Marca')"
                  :class="validateClass('Marca')"
                  :disabled="desabilitaAlterarMarca"
                />
              </div>
              <div :class="width50percent">
                <label class="vs-select--label">Ano Modelo</label>
                <v-select
                  :options="anosModelo"
                  name="Ano Modelo"
                  id="Ano Modelo"
                  @input="selecionaAnoModelo()"
                  :state="validateState('Ano Modelo')"
                  :class="validateClass('Ano Modelo')"
                  v-validate="{ required: true }"
                  v-model="idAnoModelo"
                  label="text"
                  :disabled="desabilitaAlterarAnoModelo"
                />
              </div>
              <div :class="width50percent">
                <label class="vs-select--label">Modelo</label>
                <v-select
                  :options="modelos"
                  name="Modelo"
                  id="Modelo"
                  @input="preencheAnos()"
                  v-model="idModelo"
                  v-validate="{ required: true }"
                  label="text"
                  :state="validateState('Modelo')"
                  :class="validateClass('Modelo')"
                  :disabled="desabilitaAlterarModelo"
                ></v-select>
              </div>

              <div :class="width50percent">
                <label class="vs-select--label">Ano Fabricação</label>
                <v-select
                  :options="anosFabricacao"
                  name="Ano Fabricação"
                  id="Ano Fabricação"
                  @input="buscaValorFipe()"
                  v-validate="{ required: true }"
                  :state="validateState('Ano Fabricação')"
                  :class="validateClass('Ano Fabricação')"
                  v-model="idAnoFabricacao"
                  label="text"
                  :disabled="desabilitaAlterarAnoFabricacao"
                ></v-select>
              </div>

              <div :class="width50percent">
                <vs-input
                  class="w-full"
                  v-if="exibeCilindrada"
                  label="Cilindradas"
                  name="Cilindradas"
                  id="Cilindradas"
                  type="number"
                  v-model="cilindradas"
                  v-validate="{ min: 3, required: true }"
                  :state="validateState('Cilindradas')"
                  :class="validateClass('Cilindradas')"
                />
              </div>
            </div>
          </div>
          <div v-if="placaEncontrada || form.somenteAgregado">
            <div class="vs-col w-full">
              <h4 class="mb-3 mt-6">Valores de Cobertura</h4>
              <hr class="mb-6" />
            </div>

            <div
              :class="`vs-col ${
                !exibirValorTotalConjunto ? 'sm:w-1/2' : 'sm:w-1/3'
              } w-full mb-2`"
            >
              <label for class="vs-input--label">Preço FIPE</label>
              <money
                class="vs-inputx vs-input--input normal"
                name="Preço FIPE do Caminhão"
                id="Preço FIPE do Caminhão"
                v-model="form.precoVeiculo"
                v-validate="{ required: true }"
                :state="validateState('Preço FIPE do Caminhão')"
                :danger="validateClass('Preço FIPE do Caminhão')"
                v-bind="money"
                :disabled="!form.somenteAgregado"
              ></money>
            </div>

            <div
              v-if="exibirValorTotalConjunto"
              class="vs-col sm:w-1/3 w-full mb-2"
            >
              <label for class="vs-input--label">Valor total do conjunto</label>
              <money
                class="vs-inputx vs-input--input normal"
                name="Valor total do conjunto"
                id="Valor total do conjunto"
                v-model="form.valorTotalConjunto"
                v-validate="{ required: true }"
                :state="validateState('Valor total do conjunto')"
                :danger="validateClass('Valor total do conjunto')"
                v-bind="money"
                disabled
              ></money>
            </div>

            <div
              :class="`vs-col ${
                !exibirValorTotalConjunto ? 'sm:w-1/2' : 'sm:w-1/3'
              } w-full mb-2`"
            >
              <label for class="vs-input--label"
                >Digite o valor que será coberto</label
              >
              <money
                class="vs-inputx vs-input--input normal"
                name="Valor de Cobertura"
                id="Valor de Cobertura"
                v-model="form.valorCobertura"
                v-validate="{ required: true, min: 0.01 }"
                :state="validateState('Valor de Cobertura')"
                :danger="validateClass('Valor de Cobertura')"
                v-bind="money"
                disabled
              ></money>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-end mt-8 mb-3">
        <vs-button
          class="font-medium mr-0"
          iconPack="feather"
          icon="icon-plus"
          :disabled="disableNovaProposta"
          @click.stop.prevent="adicionarVeiculoFrota"
          >Salvar Veículo</vs-button
        >
      </div>
      <div
        v-if="listFrotaVeiculos && listFrotaVeiculos.length > 0"
        class="vx-row ml-0 w-full mb-8"
      >
        <div class="text-xl mb-5 mt-3">
          Veículos já adicionados: {{ listFrotaVeiculos.length }}/{{
            qtdLimiteVeiculosFrota
          }}
        </div>
        <div class="w-full">
          <vs-collapse type="border">
            <vs-collapse-item
              v-for="(item, indexFrota) in listFrotaVeiculos"
              :key="indexFrota"
              not-arrow
              :class="{ striped: indexFrota % 2 === 0 }"
            >
              <div slot="header" class="flex justify-between">
                <div>
                  <h5 class="flex flex-col sm:flex-row gap-2">
                    <div class="uppercase">
                      {{ item.placa || item.chassi || 'Sem Placa/Chassi' }}
                    </div>
                    <div class="font-bold">
                      {{
                        item.veiculo.resultFipe.modelo || item.veiculo.modelo
                      }}
                    </div>
                    ({{ item.veiculo.resultFipe.marca || item.veiculo.marca }})
                  </h5>
                  <div class="flex justify-between">
                    <h6 class="mt-1">
                      {{
                        item.veiculo.resultFipe.anoFabricacao ||
                        item.veiculo.anoFabricacao
                      }}
                      /
                      {{
                        item.veiculo.resultFipe.ano_modelo ||
                        item.veiculo.anoModelo
                      }}
                      -
                      {{ item.idGrupo.label }}
                      {{
                        item.veiculo.resultFipe.fipe_codigo ||
                        item.valorCobertura
                      }}
                    </h6>
                  </div>
                  <div class="flex sm:hidden mt-4">
                    <vs-chip
                      v-if="
                        (item.implementos && item.implementos.length > 0) ||
                        (item.agregados && item.agregados.length > 0)
                      "
                      >Tem Complemento</vs-chip
                    >
                  </div>
                </div>
                <div class="flex items-center gap-3">
                  <div class="sm:block hidden">
                    <vs-chip
                      v-if="
                        (item.implementos && item.implementos.length > 0) ||
                        (item.agregados && item.agregados.length > 0)
                      "
                      >Tem Complemento</vs-chip
                    >
                  </div>
                  <vs-button
                    radius
                    icon-pack="feather"
                    icon="icon-trash"
                    @click.stop.prevent="removeVeiculoDaLista(indexFrota)"
                    color="danger"
                  >
                  </vs-button>
                </div>
              </div>

              <div
                class="w-full text-center"
                v-if="
                  item.implementos.length === 0 && item.agregados.length === 0
                "
              >
                Veículo sem Complementos
              </div>
              <div v-else>
                <vs-list>
                  <div v-if="item.agregados.length > 0">
                    <p class="font-bold text-black">AGREGADOS:</p>
                    <vs-list-item
                      v-for="(agregado, indexAgregado) in item.agregados"
                      :key="indexAgregado"
                      :title="`${agregado.placa || agregado.chassi} - ${
                        agregado.descricao
                      } - ${agregado.marca} - ${agregado.modelo}`"
                      :subtitle="`Valor de Cobertura: R$${agregado.valorCobertura.toFixed(
                        2,
                      )}`"
                    >
                    </vs-list-item>
                  </div>
                  <div v-if="item.implementos && item.implementos.length > 0">
                    <p class="font-bold text-black mt-5">IMPLEMENTOS:</p>
                    <vs-list-item
                      v-for="(implemento, indexImplemento) in item.implementos"
                      :key="indexImplemento"
                      :title="`${implemento.placa || implemento.chassi} - ${
                        implemento.descricao
                      } - ${implemento.marca} - ${implemento.modelo}`"
                      :subtitle="`Valor de Cobertura: R$${implemento.valorCobertura.toFixed(
                        2,
                      )}`"
                    >
                    </vs-list-item>
                  </div>
                </vs-list>
              </div>
            </vs-collapse-item>
          </vs-collapse>
        </div>
      </div>
    </div>
    <vs-popup
      :title="'Grupo de Veículos'"
      :active.sync="mostrarModalGrupos"
      style="z-index: 99999"
    >
      <vs-list>
        <vs-list-item
          v-for="(grupoTipo, index) in grupos"
          :key="index"
          :title="grupoTipo.label"
          :subtitle="grupoTipo.descricaoProdutos"
        >
          <vs-radio
            color="rgb(47,53,102)"
            id="Grupo"
            name="Grupo"
            v-model="idGrupo"
            :vs-value="grupoTipo"
            @change="
              selecionaTipo(), preencheMarca(), (mostrarModalGrupos = false)
            "
          ></vs-radio>
        </vs-list-item>
      </vs-list>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="flex-end">
          <vs-button
            @click="(mostrarModalGrupos = false), selecionaTipo"
            color="primary"
            type="gradient"
            class="mr-3 mt-2 mb-2"
            :disabled="!Object.hasOwn(idGrupo, 'label')"
            >Escolher</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>

    <vs-popup
      class="holamundo"
      title="Placa Recusada"
      :active.sync="modalPlacaRecusada"
      @close="resetBuscaPlaca()"
    >
      <h5>{{ situacaoPlaca }}</h5>

      <ul v-if="codigoSituacaoPlaca === '999'" class="mt-2 mb-2">
        <li>
          <b
            ><strong
              >{{ form.placa ? 'Placa: ' : 'Chassi: ' }}
              {{
                form.placa
                  ? `${form.placa} Placa Alternativa: ${obterPlacaAlternativa}`
                  : form.chassi
              }}</strong
            ></b
          >
        </li>
        <li>
          <b
            >Regional: <strong>{{ regionalConsultorPlaca }}</strong>
          </b>
        </li>
        <li>
          <b
            >consultor: <strong>{{ nomeConsultorPlaca }}</strong></b
          >
        </li>
      </ul>

      <h5 v-if="codigoSituacaoPlaca === '999'">
        informe outra placa para dar continuidade
      </h5>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            @click="resetBuscaPlaca()"
            type="gradient"
            color="warning"
            class="mt-5"
          >
            <feather-icon
              class="text-white"
              icon="CheckIcon"
              svgClasses="h-4 w-4"
            ></feather-icon>
            Entendi
          </vs-button>
        </div>
      </div>
    </vs-popup>

    <GenericPromptModal
      ref="confirmModal"
      title="Excluir Veiculo"
      icon="icon-alert-triangle"
      message="Tem certeza de que deseja excluir o veículo da lista?"
      iconColor="#FF4757"
      @confirmed="confirmRemoveVeiculo"
      icon-pack="feather"
    />
    <vs-popup
      class="holamundo"
      :title="`Adicionar ${popupTitle()}`"
      :active.sync="modalComplemento"
      @close="
        modalComplemento = false;
        resetFormComplemento = true;
      "
    >
      <!-- criar componete form Agregado -->
      <FormComplemento
        :idEmpresa="this.form.idEmpresa"
        :idGrupoVeiculo="idGrupoVinculoAgregado"
        :dadosComplemento="agregadoSelecionado"
        :resetFormComplemento="resetFormComplemento"
        :exibirFormCompleto="exibirFormComplementoCompleto"
        :grupos="gruposAgregados"
        :tipoComplemento="tipoConfiguracaoCaminhao"
        :permitePlacaDuplicada="this.form.regional.permitePlacaDuplicada"
        :tipoProposta="this.form.tipoProposta"
        :mascaraAgregado="mascaraAgregado"
        :mascaraImplemento="mascaraImplemento"
        :ativaMascarasVeiculos="ativaMascarasVeiculos"
        @adicionar="adicionarComplemento"
        @atualizar="AtualizarComplemento"
      >
      </FormComplemento>
    </vs-popup>
  </div>
</template>
<script>
import vSelect from 'vue-select';
import {
  consultaPlaca,
  buscarPlacaBaseBP,
  preparaPlacaParaConsulta,
} from '../../../../../services/cotacao';
import functions from '../../../../../utils/functions';
import service from '../../../../../services';
import estacionamentoService from '../../../../../services/estacionamento';
import GenericPromptModal from '../../../../../components/generic/GenericPromptModal.vue';
import dateConversion from '../../../../../utils/dateConversion';
import produtoService from '../../../../../services/produtos/index';
import FormComplemento from '../../../../forms/FormComplemento.vue';
import { deepClone } from '../../../../../utils/deepClone';
import { Money } from 'v-money';
import jwt from 'jsonwebtoken';
import { decryptData } from '../../../../../services/decryptData';
import { TIPO_VEICULO } from '../../../../../commons/constant/tipo-veiculo';

export default {
  props: {
    dadosBeneficiario: Object,
    veiculosProposta: Array,
    geraPropostaMoto: Boolean,
  },
  components: {
    'v-select': vSelect,
    GenericPromptModal,
    FormComplemento,
    Money,
  },
  watch: {
    classe: async function (newValue) {
      if (newValue === null) {
        this.radioSelecionado = null;
        this.idGrupo = [];
        this.gruposPorClasse = null;
        this.inputClasseIsTrue = false;
        this.buscaDadosGrupos();
      }
    },
    'form.veiculo.resultFipe.preco': function (newValue) {
      const valorNf = this.form.valorNf;
      this.form.precoVeiculo =
        (!this.form.isCarroZero && !valorNf) ||
        (this.form.isCarroZero && !this.verificaEmpresa())
          ? newValue
          : valorNf;

      this.calcularCoberturaConjunto();
    },
    'form.valorNf': function (value) {
      this.form.precoVeiculo =
        this.form.isCarroZero && this.verificaEmpresa()
          ? value
          : this.form.veiculo.resultFipe.preco;

      this.calcularCoberturaConjunto();
    },

    'form.idTipoEstacionamento': function () {
      this.verificaTipoEstacionamento();
    },

    'idTipoFipe.id': function (newValue) {
      if (newValue === 3 && !this.permitirSomenteAgregado) {
        this.exibirValorTotalConjunto = true;
      }

      if (newValue !== 3) {
        this.exibirValorTotalConjunto = false;
        this.permitirCaminhao = false;
        this.form.caminhao = false;

        this.permitirImplemento = false;
        this.form.implemento = false;

        this.permitirAgregado = false;
        this.form.agregado = false;

        this.permitirSomenteAgregado = false;

        this.form.implementos = [];
        this.form.agregados = [];

        this.configuracaoPropostaCaminhao = false;
      }
      this.calcularCoberturaConjunto();
      this.verificaTipoEstacionamento();
    },

    'form.precoVeiculo': function (value) {
      if (this.form.somenteAgregado) {
        this.form.valorTotalConjunto = value;
        this.form.valorCobertura = value;
      }
    },

    placaEncontrada: function (value) {
      if (
        this.form.alterarGrupoVeiculoCotacao &&
        this.naoPermitirEmpresa(120)
      ) {
        this.form.habilitaAlterarGrupo = value;
      }
    },
    permitirRestricoes(value) {
      this.restricoesSelecionadas = !value
        ? [{ idRestricao: null, descricao: 'Nenhuma Restrição' }]
        : [];
    },
    isCarroZero: function (newValue) {
      this.verificaZero(newValue);
    },
    codigoSituacaoPlaca() {
      if (this.codigoSituacaoPlaca === 0) {
        this.btnDisabled2 = false;
      }

      if (this.codigoSituacaoPlaca === 999) {
        this.btnDisabled2 = true;
      }
    },
    obterPlacaAlternativa() {
      const [placaAlternativa] = preparaPlacaParaConsulta(this.form.placa);
      return placaAlternativa;
    },
    'form.veiculo.marca'(newVal) {
      if (newVal.value) {
        this.getModeloAgregadoImplemento(newVal.value);
      }
    },
  },
  data() {
    return {
      listFrotaVeiculos: [],
      formCompleto: false,
      exibeCilindrada: false,
      cilindradas: null,
      idAnoFabricacao: null,
      idModelo: null,
      idAnoModelo: null,
      marcas: [],
      modelos: [],
      modelosAux: [],
      anosModelo: [],
      anosFabricacao: [],
      restricoes: [],
      grupos: [],
      idGrupo: {},
      idMarca: null,
      desabilitaAlterarMarca: true,
      desabilitaAlterarAnoModelo: true,
      desabilitaAlterarModelo: true,
      desabilitaAlterarAnoFabricacao: true,
      mostrarModalGrupos: false,
      radioSelecionado: null,
      produtos: [],
      produtosObrigatorios: [],
      produtosNaoObrigatorios: [],
      veiculoSemGrupo: false,
      btnDisabled2: false,
      permitirAgregado: false,
      permitirImplemento: false,
      configuracaoPropostaCaminhao: false,
      permitirCaminhao: false,
      implementoSelecionado: {},
      agregadoSelecionado: {},
      gruposAgregados: [],
      idGrupoVinculoAgregado: null,
      modalImplemento: false,
      modalComplemento: false,
      resetFormComplemento: false,
      msgValidacaoImplementoAgregado: '',
      validaImplementosAgregados: false,
      exibirformImplementoCompleto: false,
      exibirFormComplementoCompleto: false,
      tipoConfiguracaoCaminhao: null,
      desabilitaPropostaPorTipoVeiculoEstacionamento: false,
      form: {
        idEmpresa: null,
        somenteAgregado: false,
        isCarroZero: false,
        placa: null,
        chassi: null,
        idTipoEstacionamento: null,
        idGrupo: {},
        origemCadastroProposta: window.location,
        caminhao: false,
        implemento: false,
        agregado: false,
        descricaoAgregado: null,
        implementos: [],
        agregados: [],
        nf: null,
        dataNf: null,
        valorNf: 0,
        numeroMotor: null,
        renavam: null,
        combustivel: null,
        cor: null,
        quantidadePassageiro: null,
        produtosObrigatorios: [],
        produtosNaoObrigatorios: [],
        habilitaAlterarGrupo: false,
        alterarGrupoVeiculoCotacao: false,
        jsonFacilitadorProdutos: null,
        grupos: [],
        isTaxiOrApp: false,
        veiculo: {
          idGrupo: null,
          tipoVeiculo: null,
          codigoMarca: null,
          codigoModelo: null,
          anoGeral: null,
          anoModelo: null,
          anoFabricacao: null,
          codigoTipoCombustivel: null,
          combustivel: '',
          marca: null,
          modelo: null,
          codigoFipe: '',
          ano: null,
          resultFipe: {},
        },
      },
      placaValidada: null,
      dadosPlaca: null,
      placaEncontrada: false,
      exibirIptDadosVeiculo: false,
      modelosFipeEncontrados: [],
      tipos: [],
      idTipoFipe: null,
      width50percent: 'vs-col mb-4 w-full lg:w-1/2',
      width33percent: 'vs-col mb-4 w-full lg:w-1/3',
      listLocaisEstacionamento: [],
      nomeConsultorPlaca: '',
      modalPlacaRecusada: false,
      regionalConsultorPlaca: null,
      codigoSituacaoPlaca: '0',
      situacaoPlaca: '',
      idEmpresaProps: null,
      indexToDelete: null,
      foraTabela: null,
      cloneDadosBeneficiario: {},
      qtdLimiteVeiculosFrota: 100,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: true,
      },
      exibirValorTotalConjunto: false,
      classes: [],
      classe: '',
      isClasse: null,
      gruposPorClasse: [],
      controllerClasse: 'classe',
      mascaraCarro: null,
      mascaraMoto: null,
      mascaraCaminhao: null,
      mascaraAgregado: null,
      mascaraImplemento: null,
      ativaMascarasVeiculos: null,
      tipoVeiculo: TIPO_VEICULO,
      calcularDiasUteisNfVistoria: null,
      diasZeroKM: null,
      modalInfoDataSaidaNf: false,
      marcaAgregadoImplemento: [],
      modeloAgregadoImplemento: [],
      permitePlacaDuplicada: false,
      exigirCampoEstacionamentoProposta: null,
    };
  },

  computed: {
    disableNovaProposta() {
      const dadosIncompletos =
        this.veiculoSemGrupo ||
        this.btnDisabled2 ||
        this.desabilitaPropostaPorTipoVeiculoEstacionamento;
      return dadosIncompletos;
    },
  },

  methods: {
    notifyMsg(color, msg, timer = 2000) {
      return this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: msg,
        color: color,
        timer,
      });
    },

    exibirPlaca() {
      const exibirPlaca = !this.form.isCarroZero && !this.form.somenteAgregado;
      return exibirPlaca;
    },

    verificaZero() {
      if (this.form.isCarroZero) {
        this.form.placa = null;
        this.resetBuscaPlaca();

        if (this.form.alterarGrupoVeiculoCotacao) {
          this.form.habilitaAlterarGrupo = !this.form.isCarroZero;
        }
      }
    },

    preencheSelects() {
      this.buscaDadosTipos();
      this.buscaDadosTiposEstacionamento();
      this.buscarDicionarioTiposVeiculos();
    },

    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    keymonitorPlaca: async function () {
      this.btnDisabled2 = false;

      const permitirPlacaDuplicada =
        this.form.placa.length === 8 &&
        this.form.regional.permitePlacaDuplicada;
      if (permitirPlacaDuplicada) {
        this.buscaPlacaFipe();

        return;
      }

      if (this.form.placa.length === 8) {
        this.$vs.loading();
        const placaExisteFrota = await this.verificaPlacaChassiFrota(
          this.form.placa,
        );
        if (placaExisteFrota) {
          this.notifyMsg('danger', 'Placa já adicionada na lista de veículos');
          this.$vs.loading.close();
          return;
        }
        this.placaValidada = await this.consultarExisteCotacao();
        if (!this.placaValidada) {
          this.$vs.loading.close();
          return;
        }
        this.placaValidada = await this.consultarPlacaChassiBaseBP('placa');
        if (!this.placaValidada) {
          this.$vs.loading.close();
          return;
        }

        this.$vs.loading.close();
        this.buscaPlacaFipe();
      }
    },
    async consultarExisteCotacao() {
      try {
        if (this.form.somenteAgregado) {
          return true;
        }

        const identificadoVeiculo = this.form.placa || this.form.chassi;

        const tipoIdentificado =
          identificadoVeiculo.length === 17 ? 'chassi' : 'placa';

        if (!tipoIdentificado) {
          this.$vs.loading.close();

          this.notifyMsg(
            'danger',
            'Uma placa ou chassi ou valido deve ser informado',
          );

          return;
        }

        if (this.isPropostaConsultor || this.isInterno) {
          const dadosConsultaPlaca = await consultaPlaca({
            tipoIdentificado,
            identificador: this.form.placa || this.form.chassi,
            idEmpresa: this.form.idEmpresa,
            somenteAgregado: this.form.somenteAgregado,
            permitePlacaRepetida: this.permitePlacaRepetida,
          });

          if (dadosConsultaPlaca.codigoSituacao === '999') {
            this.$vs.loading.close();
            this.exibirAlertaPlaca(dadosConsultaPlaca);
            return false;
          }
        }

        return true;
      } catch (error) {
        this.notifyMsg('danger', error);
      }
    },

    naoPermitirEmpresa(idEmpresa) {
      return this.form.idEmpresa != idEmpresa;
    },

    async consultarPlacaChassiBaseBP(placa = null, chassi = null) {
      const isBP = functions.verificaEmpresaBemProtege(this.form.idEmpresa);

      if (!isBP || (!this.placaValidada && placa)) {
        return true;
      }

      const dadosConsultaPlaca = await buscarPlacaBaseBP({
        idEmpresa: this.form.idEmpresa,
        placa: placa ? this.form.placa : placa,
        chassi: chassi ? this.form.chassi : chassi,
      });

      if (dadosConsultaPlaca.codigoSituacao === '998') {
        if (
          !['Reativação', 'Troca de Titularidade'].includes(
            this.form.tipoProposta,
          )
        ) {
          this.exibirAlertaPlaca(dadosConsultaPlaca);
          return false;
        } else {
          return true;
        }
      }

      this.codigoSituacaoPlaca = '0';
      return true;
    },
    async buscaPlacaFipe() {
      if (this.form.placa.length === 8)
        try {
          this.$vs.loading();
          const retornoFipe = await service.post(
            'CotacaoAberta',
            `BuscaDadosPlaca`,
            this.form,
          );
          const { data, status } = retornoFipe;
          this.dadosPlaca = {};
          this.dadosPlaca = data;
          if (status === 204 && data === '') {
            this.buscarPlacasZerado();
          }
          if (data) {
            const tipoVeiculo = data.segmento;
            const TIPO_VEICULO = 'Moto';
            const deveOcultarMoto =
              !this.geraPropostaMoto && tipoVeiculo === TIPO_VEICULO;
            if (deveOcultarMoto) {
              this.$vs.loading.close();
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: 'Não é possível realizar propostas para motocicletas.',
                color: 'danger',
                timer: 5000,
              });
              this.placaEncontrada = false;
              this.exibirIptDadosVeiculo = true;
              this.dadosPlaca = {};
              this.habilitaAlterarGrupo = false;
              return;
            }
            this.preencheDadosPlaca();
            return;
          }
          this.placaEncontrada = false;
          this.exibirIptDadosVeiculo = true;
          this.dadosPlaca = {};
          this.form.habilitaAlterarGrupo = false;
          return;
        } catch {
          this.placaEncontrada = false;
          this.exibirIptDadosVeiculo = true;
          this.form.habilitaAlterarGrupo = false;
          this.modelosFipeEncontrados = [];
          this.formCompleto = true;
          this.notifyMsg(
            'danger',
            'Não foi possível buscar a placa, preencha os dados manualmente, ou tente novamente.',
            10000,
          );
        } finally {
          this.radioSelecionado = null;
          this.$vs.loading.close();
        }
    },

    preencheDadosPlaca() {
      const temDadosPlaca = !functions.isObjectEmpty(this.dadosPlaca);
      this.cilindradas = null;

      if (temDadosPlaca) {
        const temDadosExtraPlaca = !functions.isObjectEmpty(
          this.dadosPlaca.extra,
        );

        const temDadosFipePlaca = !functions.isObjectEmpty(
          this.dadosPlaca.fipe,
        );

        const dadosPlacaValidos =
          this.dadosPlaca.mensagemRetorno === 'Sem erros.' ||
          (temDadosExtraPlaca && temDadosFipePlaca);

        if (!dadosPlacaValidos) {
          const menssagemParaResetPlaca =
            'Nenhum modelo foi associado a essa placa';

          this.notifyMsg('warning', menssagemParaResetPlaca);
          this.placaEncontrada = false;
          this.formCompleto = true;
          this.exibirIptDadosVeiculo = true;
          return;
        }
        if (temDadosExtraPlaca) {
          this.form.resultadoPlaca = this.dadosPlaca;
          this.form.chassi = this.dadosPlaca.extra.chassi.toUpperCase();
          this.form.renavam = this.dadosPlaca.extra.renavam;
          this.form.numeroMotor = this.dadosPlaca.extra.motor;
          this.form.combustivel = this.dadosPlaca.extra.combustivel;
          this.form.cor = this.dadosPlaca.cor;
          this.form.quantidadePassageiro =
            this.dadosPlaca.extra.quantidade_passageiro;
          if (this.dadosPlaca.extra.tipo_veiculo) {
            const idTipoFipe = this.pegarTipoVeiculo(
              this.dadosPlaca.extra.tipo_veiculo,
            );
            const aux = this.tipos.find((x) => x.id === idTipoFipe);
            this.idTipoFipe = aux;
            this.exibeCilindrada = false;
            this.cilindradas = null;
            if (idTipoFipe === 2) {
              this.exibeCilindrada = true;
              this.cilindradas = this.dadosPlaca.extra.cilindradas;
            }
            this.selecionaTipoFipe();
          }
        }
        if (temDadosFipePlaca) {
          this.btnDisabled2 = true;
          this.placaEncontrada = true;
          this.exibirIptDadosVeiculo = false;
          this.formCompleto = false;
          this.modelosFipeEncontrados = [];
          this.dadosPlaca.fipe.dados.forEach((element) => {
            element.selecionado = false;
            element.checked = null;
            this.modelosFipeEncontrados.push(element);
          });
          this.modelosFipeEncontrados.sort(function (a, b) {
            return a.score > b.score ? -1 : a.score < b.score ? 1 : 0;
          });
        }
      }
    },

    pegarTipoVeiculo(tipo_veiculo) {
      const tipoVeiculo = this.dicionarioTiposVeiculos[tipo_veiculo];
      return tipoVeiculo ? tipoVeiculo.codigoTipo : 3;
    },

    exibirAlertaPlaca(dadosConsultaPlaca) {
      if (!dadosConsultaPlaca) return;

      const {
        nomeConsultorPlaca,
        regionalConsultorPlaca,
        modalPlacaRecusada,
        codigoSituacao,
      } = dadosConsultaPlaca;

      this.nomeConsultorPlaca = nomeConsultorPlaca;
      this.regionalConsultorPlaca = regionalConsultorPlaca;
      this.modalPlacaRecusada = modalPlacaRecusada;
      this.codigoSituacaoPlaca = codigoSituacao;
      this.situacaoPlaca =
        'Esta placa/chassi já existe em nosso banco de dados.';

      return;
    },

    async selecionaModelo(item) {
      for (let index = 0; index < this.modelosFipeEncontrados.length; index++) {
        const element = this.modelosFipeEncontrados[index];

        element.selecionado = null;

        if (element.codigo_fipe === item.codigo_fipe) {
          this.modeloFipeSelecionado = element.codigo_fipe;
          this.modeloFipeAnoModeloSelecionado = `${element.ano_modelo}-${element.tipo_modelo}`;
          this.idTipoModeloSelecionado = element.tipo_modelo;

          element.selecionado = true;
        }
      }
      const grupoVeiculoAux = this.idGrupo;

      await this.confirmaModeloFipe();

      if (!this.form.alterarGrupoVeiculoCotacao) {
        this.idGrupo = grupoVeiculoAux;
      }

      this.abrirModalGrupos();

      this.calcularCoberturaConjunto();

      this.anosFabricacao.unshift({ text: 'Selecione', value: null });
    },

    buscarDicionarioTiposVeiculos() {
      service
        .post('dicionarios', 'buscar-dicionario-tipos-veiculos', {})
        .then((res) => {
          this.dicionarioTiposVeiculos = res.data;
        })
        .catch((e) => {
          throw new Error(e);
        });
    },

    async confirmaModeloFipe() {
      const modelo = this.modelosFipeEncontrados.find(
        (x) => x.codigo_fipe === this.modeloFipeSelecionado,
      );

      if (!this.form.idTipoFipe) {
        const aux = this.tipos.find((x) => x.id === modelo.tipo_modelo);
        this.form.idTipoFipe = aux;
        this.idTipoFipe = aux;
        await this.selecionaTipoFipe();
      }
      this.$vs.loading();
      modelo.codigoTipoVeiculo = modelo.tipo_modelo;
      modelo.anoModelo = this.dadosPlaca.anoModelo;
      modelo.selecionado = true;
      try {
        const { data: dadosModeloFipe } = await service.post(
          'CotacaoAberta',
          'BuscaDadosFipeModelo',
          modelo,
        );

        let dadosModelo = null;

        if (this.form.alterarGrupoVeiculoCotacao) {
          let idMarca = dadosModeloFipe.id_marca;
          let idModelo = dadosModeloFipe.id_modelo;
          if (!idMarca || !idModelo) {
            const modelo = dadosModeloFipe.find(
              (_modelo) =>
                _modelo.fipe_codigo === this.modeloFipeSelecionado &&
                _modelo.id_modelo_ano === this.modeloFipeAnoModeloSelecionado,
            );

            dadosModelo = modelo;
            idMarca = modelo.id_marca;
            idModelo = modelo.id_modelo;

            if (!idMarca || !idModelo) {
              this.notifyMsg(
                'warning',
                'Não foi possível buscar dados, sistema indisponivel no momento ou falha com a conexão de internet',
                8000,
              );
              return;
            }
          }

          const tipo =
            dadosModeloFipe.tipo ||
            dadosModelo.tipo ||
            this.idTipoModeloSelecionado;
          const anoFabricacao = dadosModeloFipe.ano;
          const anoModelo = dadosModeloFipe.ano_modelo;
          const idEmpresa = this.form.idEmpresa;
          const chassi = this.form.chassi
            ? this.form.chassi
            : this.dadosPlaca.extra
            ? this.dadosPlaca.extra.chassi
            : '';
          const importado = await functions.verificaVeiculoImportado(
            chassi,
            idEmpresa,
            this.idEmpresaProps,
          );
          const objBuscaGrupo = {
            idEmpresa,
            idMarca,
            idModelo,
            tipo,
            anoFabricacao,
            anoModelo,
            importado: this.verificaEmpresa() ? importado : null,
          };

          const objGrupos = await service.post(
            'CotacaoAberta',
            'buscaGrupoMarcaModelo',
            objBuscaGrupo,
          );

          if (this.inputClasseIsTrue) {
            const objGruposClone = deepClone(objGrupos.data);
            const gruposComMesmoId = objGruposClone.filter((obj) => {
              return this.gruposPorClasse.some(
                (grupo) => grupo.idGrupo === obj.id,
              );
            });
            objGrupos.data = gruposComMesmoId;
          }

          this.preencheGruposPosSelecao(objGrupos);

          if (objGrupos.data.length === 0) {
            this.verificaEmpresa() && this.separaGruposImportados();
            this.form.habilitaAlterarGrupo = false;
            this.idGrupo = null;
            this.grupos = [];

            this.verificaVeiculoSemGrupo();
            this.notifyMsg('danger', 'Nenhum grupo encontrado', 5000);
          }

          if (objGrupos.data && objGrupos.data.length > 0) {
            this.idGrupo = objGrupos.data[0];
            this.grupos = objGrupos.data;
            this.exibeCilindrada = this.idGrupo.idTipoFipe === 2;
            this.permitirCaminhao = true;
            this.permitirAgregado = this.idGrupo.permiteAgregado;
            this.permitirImplemento = this.idGrupo.permiteImplemento;
            this.permitirSomenteAgregado = this.idGrupo.permiteSomenteAgregado;
            this.form.somenteAgregado = this.permitirSomenteAgregado;
            this.configuracaoPropostaCaminhao =
              this.idGrupo.permiteAgregado || this.idGrupo.permiteImplemento;
            this.form.habilitaAlterarGrupo = true;
          }

          if (objGrupos.data && objGrupos.data.length > 1) {
            this.form.habilitaAlterarGrupo = true;

            this.verificaEmpresa() &&
              this.separaGruposImportados(objGrupos.data);
          }
        }

        this.form.veiculo.resultFipe = !dadosModelo
          ? dadosModeloFipe
          : dadosModelo;
        this.form.veiculo.anoModelo = this.dadosPlaca.anoModelo
          ? parseInt(this.dadosPlaca.anoModelo)
          : null;
        this.form.veiculo.anoFabricacao = this.dadosPlaca.ano
          ? parseInt(this.dadosPlaca.ano)
          : null;
        this.form.veiculo.combustivel = !dadosModelo
          ? dadosModeloFipe.combustivel
          : dadosModelo.combustivel;
        this.fipeEncontrada = true;
        this.btnDisabled2 = false;
        this.$forceUpdate();
      } catch (e) {
        this.notifyMsg('danger', 'Falha ao confirmar modelo da Fipe');
      } finally {
        this.$vs.loading.close();
      }
    },
    async buscaDadosTipos() {
      try {
        const { data } = await service.getAll('g/domTipoFipe', {}, 'list/');
        const _data = decryptData(data);
        const TIPO_VEICULO = 'Moto';

        const tiposUnicos = new Set();

        _data.forEach(({ idTipoFipe, nomeTipo, deletedAt }) => {
          if (!deletedAt) {
            tiposUnicos.add(
              JSON.stringify({ id: idTipoFipe, label: nomeTipo }),
            );
          }
        });

        const tiposFiltrados = Array.from(tiposUnicos).map(JSON.parse);
        if (!this.geraPropostaMoto) {
          this.tipos = tiposFiltrados.filter(
            ({ label }) => label !== TIPO_VEICULO,
          );
        } else {
          this.tipos = tiposFiltrados;
        }

        const tiposTemp = [];
        this.tipos.forEach((item) => {
          if (!item.deletedAt) {
            let label = item.label;
            if (this.ativaMascarasVeiculos) {
              if (label === 'Carro' && this.mascaraCarro) {
                label = this.mascaraCarro;
              }
              if (label === 'Moto' && this.mascaraMoto) {
                label = this.mascaraMoto;
              }
              if (label === 'Caminhão' && this.mascaraCaminhao) {
                label = this.mascaraCaminhao;
              }
            }
            tiposTemp.push({
              id: item.id,
              label: label,
            });
          }
        });
        this.tipos = tiposTemp;
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Erro ao Buscar Dados',
          color: 'danger',
          timer: 5000,
        });
      }
    },

    verificaChassiBaseBP: async function () {
      if (this.form.somenteAgregado && !this.form.chassi) {
        return;
      }

      if (this.form.chassi && this.form.chassi.length === 17) {
        this.placaValidada = await this.consultarExisteCotacao();

        if (!this.placaValidada) {
          return;
        }
        this.formCompleto = true;
        await this.consultarPlacaChassiBaseBP(null, 'chassi');
      }
    },

    async preencheMarca() {
      const desabilita = !this.idGrupo;
      this.desabilitaAlterarMarca = desabilita;
      this.desabilitaAlterarAnoModelo = desabilita;
      this.desabilitaAlterarModelo = desabilita;
      this.desabilitaAlterarAnoFabricacao = desabilita;

      if (!this.placaEncontrada) {
        return;
      }

      const obj = {
        idGrupo: { id: this.form.veiculo.idGrupo },
        idEmpresa: this.form.idEmpresa,
      };
      this.resetVehicleFormFields();
      this.$vs.loading();

      try {
        const res = await service.post(
          'CotacaoAberta',
          'ConsultaMarcasModeloPorGrupo',
          obj,
        );
        this.processResponseData(res.data);
      } catch (e) {
        this.notifyMsg('danger', e);
      } finally {
        this.$vs.loading.close();
      }
    },

    resetVehicleFormFields() {
      this.form.veiculo.marca = null;
      this.form.veiculo.modelo = null;
      this.form.veiculo.anoGeral = null;
      this.form.veiculo.anoFabricacao = null;
      this.form.cilindradas = null;
      this.idMarca = null;
      this.marcas = [];
      this.modelos = [];
      this.anosModelo = [];
      this.anosFabricacao = [];
    },

    processResponseData(data) {
      if (data && data.length > 0) {
        this.isGrupoModelos = true;
        this.marcas = [];
        this.modelosAux = [];
        data.forEach((element) => {
          this.updateMarcasModelos(element);
        });
        this.buscaDadosFipe('ConsultarMarcas', 'marcas', 'name', 'id');
        this.marcas.unshift({ id: null, text: 'Selecione' });
      } else {
        this.isGrupoModelos = false;
        this.buscaDadosFipe('ConsultarMarcas', 'marcas', 'name', 'id');
      }
    },

    updateMarcasModelos(element) {
      const aux = this.marcas.some((x) => x.value.id === element.idMarca);
      const auxModelos = this.modelosAux.some(
        (y) => y.value.id === element.idModelo,
      );

      if (!aux) {
        this.marcas.push({
          value: {
            id: element.idMarca,
            valor: element.marca,
            isGrupoModelos: true,
          },
          text: element.marca,
        });
      }

      if (!auxModelos) {
        this.modelosAux.push({
          idMarca: element.idMarca,
          idTipo: element.idTipo,
          value: {
            id: element.idModelo,
            valor: element.modelo,
            isGrupoModelos: true,
          },
          text: element.modelo,
        });
      }
    },

    preencheModelo() {
      this.modelos = [];
      this.anosModelo = [];
      this.anosFabricacao = [];
      if (this.idMarca) {
        this.form.veiculo.marca = this.idMarca.value
          ? this.idMarca.value
          : this.idMarca.text;
        this.form.veiculo.codigoMarca = this.idMarca.value
          ? this.idMarca.value.id
          : this.idMarca.id;
      } else {
        this.form.veiculo.marca = null;
        this.form.veiculo.codigoMarca = null;
        this.idModelo = null;
        this.idAnoModelo = null;
        this.idAnoFabricacao = null;
      }
      this.form.veiculo.modelo = null;
      this.form.veiculo.anoGeral = null;
      this.form.veiculo.anoFabricacao = null;

      this.desabilitaAlterarAnoModelo = false;
      this.desabilitaAlterarModelo = false;

      this.form.cilindradas = null;
      this.selecionaTipo();

      if (!this.form.veiculo.marca.isGrupoModelos) {
        this.buscaDadosFipe('ConsultarModelos', 'modelos', 'name', 'id');
      } else {
        this.modelos = this.modelosAux.filter(
          (x) => x.idMarca === this.form.veiculo.marca.id,
        );
      }
    },

    async preencheAnos() {
      if (!this.idModelo) {
        this.idAnoFabricacao = null;
        return;
      }

      this.form.veiculo.modelo = this.idModelo.value;
      this.form.veiculo.anoGeral = null;
      this.anosModelo = [];
      this.form.cilindradas = null;
      this.idAnoFabricacao = null;
      if (this.form.veiculo.marca.isGrupoModelos) {
        const modeloAux = this.modelosAux.find(
          (x) => x.value.id === this.form.veiculo.modelo.id,
        );
        this.form.veiculo.tipoVeiculo = modeloAux.idTipo;
      }

      this.form.veiculo.codigoModelo = this.form.veiculo.modelo.id;
      await this.buscaDadosFipe(
        'ConsultarAnoModelo',
        'anosModelo',
        'name',
        'id',
      );

      const auxAnos = [];

      this.anosModelo.forEach((element) => {
        if (element.value) {
          const ano = element.value.valor.split(' ')[0];
          const combustivel = element.value.valor.split(' ')[1];
          const codigoTipoCombustivel = element.value.id.split('-')[1];
          if (ano <= new Date().getFullYear() + 1) {
            auxAnos.push({
              value: {
                ano: ano,
                combustivel: combustivel,
                codigoTipoCombustivel: codigoTipoCombustivel,
              },
              text: element.value.valor.includes('32000')
                ? '0km'
                : element.value.valor,
            });
          }
        }
      });
      this.anosModelo = auxAnos;
    },
    selecionaAnoModelo() {
      if (!this.idAnoModelo) {
        this.$emit('option:deselected', this.preencheModelo());
        this.idModelo = null;
        this.idAnoFabricacao = null;
      } else {
        this.form.veiculo.anoGeral = this.idAnoModelo.value;
        this.form.veiculo.ano = this.form.veiculo.anoGeral.ano;
        this.form.veiculo.codigoTipoCombustivel =
          this.form.veiculo.anoGeral.codigoTipoCombustivel;
        this.form.veiculo.anoModelo = this.form.veiculo.anoGeral.ano;
        this.form.veiculo.combustivel = this.form.veiculo.anoGeral.combustivel;
        this.desabilitaAlterarAnoFabricacao = false;

        this.form.veiculo.anoFabricacao = null;
        this.form.cilindradas = null;
        this.idAnoFabricacao = [];
        this.anosFabricacao = [];

        let _anoFabricao = {
          value: this.form.veiculo.anoModelo - 1,
          text: this.form.veiculo.anoModelo - 1,
        };

        this.anosFabricacao = [
          {
            value: this.form.veiculo.anoModelo,
            text:
              this.form.veiculo.anoModelo === '32000'
                ? '0km'
                : this.form.veiculo.anoModelo,
          },
          {
            ..._anoFabricao,
          },
        ];

        this.buscaDadosFipe(
          'ConsultarModelosPorAno',
          'modelosPorAno',
          'name',
          'id',
        );
      }
    },

    async buscaDadosTiposEstacionamento() {
      try {
        this.$vs.loading();
        const { data } = await estacionamentoService.buscar();
        this.listLocaisEstacionamento = data;
      } catch (error) {
        this.notifyMsg(
          'danger',
          'Não foi possível buscar os locais de estacionamento, tente novamente',
          5000,
        );
      } finally {
        this.$vs.loading.close();
      }
    },

    abrirModalGrupos() {
      if (!this.idTipoFipe) return;
      if (this.grupos) {
        this.veiculoSemGrupo = false;
        if (this.grupos.length === 0) {
          this.idGrupo = null;
          this.verificaVeiculoSemGrupo();
          return;
        }
        if (this.grupos.length === 1) {
          this.idGrupo = this.grupos[0];
          return;
        }
        this.mostrarModalGrupos = true;
      }
    },

    async selecionaTipoFipe() {
      if (!this.idTipoFipe) return;
      this.form.habilitaAlterarGrupo = false;
      this.idGrupo = {};
      this.marcas = [];
      this.modelos = [];
      this.anosModelo = [];
      this.anosFabricacao = [];
      this.idMarca = null;
      this.idModelo = null;
      this.idAnoModelo = null;
      this.idAnoFabricacao = null;
      this.desabilitaAlterarMarca = true;
      this.desabilitaAlterarAnoModelo = true;
      this.desabilitaAlterarModelo = true;
      this.desabilitaAlterarAnoFabricacao = true;
      this.grupos = [];

      await this.buscaDadosGrupos();

      if (!this.placaEncontrada) {
        this.desabilitaAlterarMarca = false;
        if (this.idTipoFipe) {
          this.buscaMarcasPorTipoVeiculo(this.idTipoFipe);
          this.form.veiculo.tipoVeiculo = this.idTipoFipe.id;
        }
      }

      if (this.idTipoFipe) {
        const tipoFipe = this.idTipoFipe.id;
        const tipoCaminhao = tipoFipe === this.tipoVeiculo.CAMINHAO;
        this.form.caminhao = tipoCaminhao;
        if (tipoCaminhao) {
          this.form.isTaxiOrApp = false;
        }
      }
    },

    async buscaDadosGrupos() {
      this.$vs.loading();
      try {
        const { data } = await service.getAll(
          'Grupo',
          {},
          'list/' + this.form.idEmpresa,
        );

        this.grupos = [];

        if (!this.idTipoFipe.id) {
          this.idTipoFipe = this.idTipoFipeAux;
        }

        data.forEach((element) => {
          if (!element.deletedAt) {
            if (
              element.idTipoFipe === this.idTipoFipe.id &&
              !this.form.somenteAgregado
            ) {
              this.grupos.push({
                id: element.idGrupo,
                label: element.nomeGrupo,
                descricao: element.descricao,
                importado: element.importado,
                idTipoFipe: element.idTipoFipe,
                descricaoProdutos: element.descricaoProdutos,
                permiteAgregado: element.permiteAgregado,
                permiteSomenteAgregado: element.permiteSomenteAgregado,
                permiteImplemento: element.permiteImplemento,
                gruposAgregados: element.permiteAgregado
                  ? element.gruposAgregados
                  : null,
              });
            }

            if (this.form.somenteAgregado && element.permiteSomenteAgregado) {
              this.grupos.push({
                id: element.idGrupo,
                label: element.nomeGrupo,
                descricao: element.descricao,
                importado: element.importado,
                idTipoFipe: element.idTipoFipe,
                descricaoProdutos: element.descricaoProdutos,
                permiteAgregado: element.permiteAgregado,
                permiteSomenteAgregado: element.permiteSomenteAgregado,
                permiteImplemento: element.permiteImplemento,
                gruposAgregados: element.permiteAgregado
                  ? element.gruposAgregados
                  : null,
              });
            }
          }
        });

        this.$vs.loading.close();
      } catch (e) {
        throw Error(e);
      } finally {
        this.$vs.loading.close();
      }
    },
    async buscaMarcasPorTipoVeiculo(tipoVeiculo) {
      const objSend = {
        tipoVeiculo: tipoVeiculo.id,
      };

      try {
        this.$vs.loading();
        const { data } = await service.post(
          'Fipe',
          'consultar-marcas-por-tipo-veiculo',
          objSend,
        );
        this.marcas = data;
      } catch (error) {
        this.notifyMsg(
          'danger',
          'Falha ao busca os marcas, falha na conexão com a internet ou serviço indisponível. Tente novamente',
          5000,
        );
      } finally {
        this.$vs.loading.close();
      }
    },

    resetBuscaPlaca(infoResetPlaca = null) {
      this.form = {
        ...this.cloneDadosBeneficiario,
        placa: null,
        chassi: null,
        idTipoEstacionamento: null,
        idGrupo: {},
        origemCadastroProposta: window.location,
        caminhao: false,
        implemento: false,
        agregado: false,
        descricaoAgregado: null,
        implementos: [],
        agregados: [],
        nf: null,
        dataNf: null,
        valorNf: 0,
        numeroMotor: null,
        renavam: null,
        combustivel: null,
        cor: null,
        quantidadePassageiro: null,
        produtos: [],
        produtosObrigatorios: [],
        produtosNaoObrigatorios: [],
        grupos: [],
        veiculo: {
          idGrupo: null,
          tipoVeiculo: null,
          codigoMarca: null,
          codigoModelo: null,
          anoGeral: null,
          anoModelo: null,
          anoFabricacao: null,
          codigoTipoCombustivel: null,
          combustivel: '',
          marca: null,
          modelo: null,
          codigoFipe: '',
          ano: null,
          resultFipe: {},
        },
        jsonFacilitadorProdutos: null,
      };
      this.placaEncontrada = false;
      this.btnDisabled = false;
      this.dadosPlaca = {};
      this.modelosFipeEncontrados = [];
      this.idGrupo = {};
      this.idTipoFipe = { label: '' };
      this.exibeCilindrada = false;
      this.modalPlacaRecusada = false;

      if (infoResetPlaca !== null) {
        this.notifyMsg('warning', infoResetPlaca);
      }
      this.calcularCoberturaConjunto();
      if (this.form.somenteAgregado) {
        this.ajustarPropostaParaSomenteAgregado();
      }
    },

    resetFormCompleto() {
      this.formCompleto = false;
      this.idAnoFabricacao = null;
      this.idModelo = null;
      this.idAnoModelo = null;
      this.marcas = [];
      this.modelos = [];
      this.modelosAux = [];
      this.anosModelo = [];
      this.anosFabricacao = [];
      this.produtos = [];
      this.produtosObrigatorios = [];
      this.produtosNaoObrigatorios = [];
      this.restricoes = [];
      this.idMarca = null;
      this.desabilitaAlterarMarca = true;
      this.desabilitaAlterarAnoModelo = true;
      this.desabilitaAlterarModelo = true;
      this.desabilitaAlterarAnoFabricacao = true;
      this.mostrarModalGrupos = false;
      this.radioSelecionado = null;
      this.placaValidada = null;
      this.exibirIptDadosVeiculo = false;
      this.nomeConsultorPlaca = '';
      this.modalPlacaRecusada = false;
      this.regionalConsultorPlaca = null;
      this.codigoSituacaoPlaca = '0';
      this.situacaoPlaca = '';
      this.resetBuscaPlaca();
      this.classe = null;
      if (this.form.somenteAgregado) {
        this.ajustarPropostaParaSomenteAgregado();
      }
    },

    async adicionarVeiculoFrota() {
      const veiculo = this.form.veiculo;

      if (veiculo.marca && veiculo.marca.label) {
        veiculo.marca = veiculo.marca.label;
      }

      if (veiculo.modelo && veiculo.modelo.label) {
        veiculo.modelo = veiculo.modelo.label;
      }

      const formValid = await this.$validator.validateAll();
      if (!formValid) {
        this.notifyMsg('danger', 'Preencha todos os campos.');
        return;
      }
      const grupoVazio = Object.keys(this.idGrupo).length === 0;
      if (grupoVazio) {
        this.notifyMsg(
          'danger',
          'Não foi possivel atribuir um grupo ao veículo.',
        );
        return;
      }
      const limiteVeiculosLista =
        this.listFrotaVeiculos.length < this.qtdLimiteVeiculosFrota;
      if (!limiteVeiculosLista) {
        this.notifyMsg(
          'danger',
          `O limite de ${this.qtdLimiteVeiculosFrota} veículos na frota foi atingido, não foi possível adicionar!`,
          5000,
        );
        return;
      }
      const configuracoesCaminhaoValidas = this.validaConfiguracaoCaminhao();
      if (!configuracoesCaminhaoValidas) {
        this.notifyMsg('danger', this.msgValidacaoImplementoAgregado);
        return;
      }

      if (
        !this.form.regional.permitePlacaDuplicada &&
        !this.form.somenteAgregado
      ) {
        this.placaValidada = await this.consultarExisteCotacao();
        if (!this.placaValidada) {
          return;
        }
        await this.consultarPlacaChassiBaseBP('placa', 'chassi');
        if (!this.placaValidada) {
          return;
        }
      }

      let precoVeiculo = '0';
      const price = {
        value: '0',
      };

      let valorNf =
        typeof this.form.valorNf === 'string'
          ? this.form.valorNf.replace('R$ ', '').replace('.', '')
          : this.form.valorNf;

      if (this.form.veiculo.resultFipe.preco) {
        price.value = this.form.veiculo.resultFipe.preco
          .slice(3)
          .replace(',', '.');
      }

      precoVeiculo =
        typeof this.form.precoVeiculo === 'string'
          ? this.form.precoVeiculo.slice(3).replace(',', '.')
          : this.form.precoVeiculo;

      precoVeiculo = parseFloat(precoVeiculo);
      price.value = !this.form.somenteAgregado
        ? parseFloat(price.value)
        : precoVeiculo;
      valorNf = parseFloat(valorNf);

      if (this.isCarroZero && valorNf === 0 && !this.verificaEmpresa()) {
        this.notifyMsg(
          'danger',
          'Favor informar o valor da Nota Fiscal do Veículo',
        );
        return;
      }

      const precoIsZero = precoVeiculo === 0 || this.form.valorCobertura === 0;
      const _veiculoZero = valorNf === 0 && this.form.isCarroZero;
      const veiculoNaoZero = !this.isCarroZero;
      if (
        (precoIsZero || _veiculoZero) &&
        veiculoNaoZero &&
        !this.form.somenteAgregado
      ) {
        this.notifyMsg('danger', 'Preço FIPE ou Valor de cobertura zerado');
        return;
      }
      this.form.idGrupo = this.idGrupo || this.form.veiculo.idGrupo;
      this.form.grupos = this.grupos;

      try {
        this.$vs.loading();
        this.form.produtos = this.produtos;
        const temProdutos = await this.buscarProdutosVeiculo();
        if (!temProdutos) {
          return;
        }
        this.form.jsonFacilitadorProdutos = JSON.stringify(this.produtos);
        this.form.produtosObrigatorios = this.produtosObrigatorios;
        this.form.produtosNaoObrigatorios = this.produtosNaoObrigatorios;
        this.listFrotaVeiculos.push(deepClone(this.form));
        this.placaEncontrada = false;
        this.resetFormCompleto();
      } catch {
        this.notifyMsg(
          'danger',
          'Não foi possível adicionar veículo na lista.',
        );
      } finally {
        this.$vs.loading.close();
      }
    },

    async buscaDadosFipe(action, array, campoDescricao, campoPK) {
      this.$vs.loading();

      const formFipe = {
        idEmpresa: !this.$route.params.idEmpresa
          ? this.form.idEmpresa
          : this.$route.params.idEmpresa,
        codigoTabelaReferencia: this.codigoTabelaReferencia,
        codigoTipoVeiculo: this.form.veiculo.tipoVeiculo || this.idTipoFipe.id,
        codigoMarca: this.form.veiculo.codigoMarca,
        ano:
          this.form.veiculo.anoModelo +
          '-' +
          this.form.veiculo.codigoTipoCombustivel,
        codigoTipoCombustivel: this.form.veiculo.codigoTipoCombustivel,
        anoModelo: this.form.veiculo.anoModelo,
        codigoModelo: this.form.veiculo.codigoModelo,
      };

      try {
        const { data } = await service.post('Fipe', action, formFipe);
        const arrayRes = data;

        if (array === 'form.veiculo.resultFipe') {
          this.form.veiculo.resultFipe = arrayRes;
          return;
        }

        if (array === 'modelos') {
          this.modelos = [];
          arrayRes[0].forEach((element) => {
            this.modelos.push({
              value: { id: element['id'], valor: element['name'] },
              text: element['name'],
            });
          });

          this.anosModelo = [];
          arrayRes[1].forEach((element) => {
            let combustivel = element.name.split(' ')[1];

            if (this.idTipoFipe.id === 2) {
              combustivel = '';
            }

            if (this.idTipoFipe.id === 3) {
              combustivel = 'Diesel';
            }

            this.anosModelo.push({
              value: {
                ano: element.name.split(' ')[0],
                combustivel: element.name.split(' ')[1],
                codigoTipoCombustivel: element.id.split('-')[1],
              },
              text: element.name.includes('32000')
                ? `0km ${combustivel}`
                : element.name,
            });
          });
          return;
        }

        if (array === 'modelosPorAno') {
          this.modelos = [];
          arrayRes.forEach((element) => {
            this.modelos.push({
              value: { id: element['id'], valor: element['name'] },
              text: element['name'],
            });
          });
          return;
        }

        arrayRes.map((element) => {
          if (array === 'codigoTabelaReferencia') {
            this[array] = element[campoPK];
            return;
          }
          this[array].push({
            value: {
              id: element[campoPK],
              valor: element[campoDescricao],
            },
            text: element[campoDescricao],
          });
        });
      } catch (error) {
        this.notifyMsg('danger', 'Ocorreu um erro, por favor tente novamente!');
      } finally {
        this.$vs.loading.close();
      }
    },

    validarDataSaidaNf() {
      if (this.form.idEmpresa === 119) {
        return;
      }

      let dataValida = false;
      this.btnDisabled2 = true;
      const dataNfValida = this.form.dataNf.length === 10;
      let exibirAlerta = false;

      if (dataNfValida) {
        dataValida = dateConversion.verificarSaidaNotaFiscal(
          this.form.dataNf,
          this.calcularDiasUteisNfVistoria,
          this.diasZeroKM,
        );
        if (this.diasZeroKM === 0) {
          dataValida = false;
        }
        this.btnDisabled2 = !dataValida;
        if (dataValida) {
          return dataValida;
        }
      }

      exibirAlerta = dataNfValida && !dataValida;
      this.modalInfoDataSaidaNf = exibirAlerta;
    },

    selecionaTipo() {
      if (this.idGrupo) {
        const grupoSelecionado = this.idGrupo;
        this.configuracaoPropostaCaminhao =
          grupoSelecionado.permiteAgregado ||
          grupoSelecionado.permiteImplemento;

        this.permitirCaminhao =
          grupoSelecionado.idTipoFipe === TIPO_VEICULO.CAMINHAO;
        this.permitirCaminhao = true;
        this.permitirImplemento = grupoSelecionado.permiteImplemento;
        this.permitirAgregado = grupoSelecionado.permiteAgregado;
        this.permitirSomenteAgregado = grupoSelecionado.permiteSomenteAgregado;
      }

      if (this.permitirSomenteAgregado) {
        this.form.somenteAgregado = true;
      }

      if (!this.placaEncontrada) return;

      const tipoVeiculo = this.tipos.find(
        (tipo) => tipo.id === this.idGrupo.idTipoFipe,
      );
      this.idTipoFipe = tipoVeiculo;

      const verificaTipoSelecionado = this.modelosFipeEncontrados.find(
        (modelo) => modelo.codigo_fipe === this.modeloFipeSelecionado,
      );
      const tipoVeiculoCorreto =
        verificaTipoSelecionado.tipo_modelo === this.idTipoFipe.id;

      if (verificaTipoSelecionado && !tipoVeiculoCorreto) {
        this.notifyMsg(
          'warning',
          'O tipo de veículo não é compatível com o tipo do grupo selecionado',
        );

        this.resetBuscaPlaca();
        return;
      }

      this.form.veiculo.idGrupo = this.idGrupo ? this.idGrupo.id : null;
      this.idMarca = null;
      this.idModelo = null;
      this.idAnoModelo = null;
      this.idAnoFabricacao = null;
      this.modelos = [];
      this.anosModelo = [];
      this.anosFabricacao = [];

      this.form.veiculo.tipoVeiculo = this.idGrupo
        ? this.idGrupo.idTipoFipe
        : null;

      this.exibeCilindrada = this.idGrupo && this.idGrupo.idTipoFipe === 2;
    },

    async buscaValorFipe() {
      this.form.veiculo.anoFabricacao = this.idAnoFabricacao.value;
      await this.buscaDadosFipe(
        'ConsultarValorComTodosParametros',
        'form.veiculo.resultFipe',
        '',
        '',
      );
      await this.marcaGrupoPorModelo();
      this.calcularCoberturaConjunto();
    },
    async marcaGrupoPorModelo() {
      if (this.form.alterarGrupoVeiculoCotacao) {
        const idMarca = this.form.veiculo.codigoMarca;
        const idModelo = this.form.veiculo.codigoModelo;

        if (!idMarca || !idModelo) {
          this.$vs.loading().close();

          this.notifyMsg(
            'warning',
            'Não foi possível buscar os grupos, sistema temporariamente indisponivel ou falha de conexão com a internet.',
            5000,
          );
          return;
        }

        const tipo = this.form.veiculo.tipoVeiculo || this.idTipoFipe.id;
        const anoFabricacao = this.form.veiculo.anoFabricacao;
        const anoModelo = this.form.veiculo.anoModelo;
        const idEmpresa = this.form.idEmpresa;
        let chassi = null;
        if (this.dadosPlaca || this.form.chassi)
          chassi = this.form.chassi
            ? this.form.chassi
            : this.dadosPlaca.extra
            ? this.dadosPlaca.extra.chassi
            : '';
        const importado = await functions.verificaVeiculoImportado(
          chassi,
          idEmpresa,
          this.idEmpresaProps,
        );
        const objBuscaGrupo = {
          idEmpresa: idEmpresa,
          idMarca,
          idModelo,
          tipo,
          anoFabricacao,
          anoModelo,
          importado: this.verificaEmpresa() ? importado : null,
        };

        const objGrupos = await service.post(
          'CotacaoAberta',
          'buscaGrupoMarcaModelo',
          objBuscaGrupo,
        );
        this.preencheGruposPosSelecao(objGrupos);
      }
    },

    calcularCoberturaConjunto() {
      const temPrecoFipe = this.form.veiculo.resultFipe.preco;

      const precoFIPE = temPrecoFipe
        ? parseFloat(
            this.form.veiculo.resultFipe.preco
              .replace('R$ ', '')
              .replace('.', ''),
          )
        : 0;

      const temValorNf = this.form.valorNf;
      const valorNF =
        temValorNf && typeof this.form.valorNf === 'string'
          ? parseFloat(
              this.form.valorNf
                .replace('R$ ', '')
                .replace('.', '')
                .replace(',', '.'),
            )
          : 0;
      const veiculoZero = this.form.isCarroZero;
      let preco = veiculoZero ? valorNF : precoFIPE;

      if (veiculoZero && this.verificaEmpresa()) {
        preco = precoFIPE;
        this.form.valorNf = precoFIPE;
      }

      let totalValorImplemento = 0;
      let valorTotalConjunto = 0;

      this.form.implementos.forEach((implemento) => {
        const { valorCobertura, valorNf } = implemento;
        totalValorImplemento += valorNf > 0 ? valorNf : valorCobertura;
      });

      valorTotalConjunto = preco + totalValorImplemento;

      this.form.valorTotalConjunto = valorTotalConjunto;
      this.form.valorCobertura = valorTotalConjunto || precoFIPE;
    },

    preencheGruposPosSelecao(objGrupos) {
      if (objGrupos.data) {
        const { data } = objGrupos;
        if (data.length === 0) {
          this.form.habilitaAlterarGrupo = false;
          this.verificaVeiculoSemGrupo();
        }

        if (data && data.length > 0) {
          if (this.idGrupo) {
            let grupoExistente = data.find((x) => x.id === this.idGrupo.id);
            if (!grupoExistente) {
              this.idGrupo = data[0];
            }
          } else {
            this.idGrupo = data[0];
          }

          this.grupos = data;
          const temClasse =
            this.gruposPorClasse && this.gruposPorClasse.length > 0;
          if (temClasse) {
            const indiceGruposPorClasse = {};
            for (const grupoPorSubTipo of this.gruposPorClasse) {
              indiceGruposPorClasse[grupoPorSubTipo.id_grupo] = true;
            }
            this.grupos = this.grupos.filter(
              (grupo) => indiceGruposPorClasse[grupo.id],
            );
          }

          this.exibeCilindrada = this.idGrupo.idTipoFipe === 2;
          this.permitirCaminhao = true;
          this.permitirAgregado = this.idGrupo.permiteAgregado;
          this.permitirImplemento = this.idGrupo.permiteImplemento;
          this.permitirSomenteAgregado = this.idGrupo.permiteSomenteAgregado;
          this.form.somenteAgregado = this.permitirSomenteAgregado;
          this.configuracaoPropostaCaminhao =
            this.idGrupo.permiteAgregado || this.idGrupo.permiteImplemento;
          this.form.habilitaAlterarGrupo = false;
        }

        if (data && data.length > 1) {
          this.notifyMsg(
            'warning',
            'Mais de Um grupo encontrado, selecione um grupo de Veículo',
            5000,
          );
          this.form.habilitaAlterarGrupo = true;
          this.abrirModalGrupos();
        }
      }
    },
    verificaEmpresa() {
      return functions.verificaEmpresaBemProtege(this.form.idEmpresa);
    },
    chassiToUpperCase(chassi) {
      if (chassi) {
        this.form.chassi = chassi.toUpperCase();
      }
    },
    verificaVeiculoSemGrupo() {
      if (this.form.idEmpresa === 120) {
        this.veiculoSemGrupo = true;
      }
    },

    verificaTipoEstacionamento() {
      if (!this.idTipoFipe || !this.form.idTipoEstacionamento) {
        return;
      }

      if (
        this.idTipoFipe.id === 2 &&
        this.form.idTipoEstacionamento === 2 &&
        !this.liberaPropostaMotoNaRua
      ) {
        this.desabilitaPropostaPorTipoVeiculoEstacionamento = true;
        this.notifyMsg(
          'danger',
          'Não é possível criar propostas de motocicletas que não possuam estacionamento privado.',
        );
        return;
      }
      this.desabilitaPropostaPorTipoVeiculoEstacionamento = false;
    },

    async separaGruposImportados(grupos = this.grupos) {
      const chassi = this.form.chassi
        ? this.form.chassi
        : this.dadosPlaca.extra
        ? this.dadosPlaca.extra.chassi
        : '';
      const importado = await functions.verificaVeiculoImportado(
        chassi,
        this.form.idEmpresa,
        this.idEmpresaProps,
      );
      const gruposImportados = grupos.filter(
        (grupo) => grupo.importado === importado,
      );
      this.grupos = gruposImportados.length ? gruposImportados : grupos;
    },

    validaConfiguracaoCaminhao() {
      this.validaImplementosAgregados = false;
      this.msgValidacaoImplementoAgregado = '';

      const configuracaoAgregado = this.form.agregado;
      const configuracaoImplemento = this.form.implemento;

      if (configuracaoAgregado || configuracaoImplemento) {
        const temAgregados = this.form.agregados && this.form.agregados.length;
        const temImplemento =
          thiis.form.implementos && this.form.implementos.length;

        const msgValidaAgregado =
          temAgregados === 0 && configuracaoAgregado
            ? 'É necessario adicionar um agregado'
            : '';

        if (msgValidaAgregado && temAgregados === 0) {
          this.msgValidacaoImplementoAgregado = msgValidaAgregado;
          this.validaImplementosAgregados = true;
          return false;
        }

        if (msgValidaAgregado === '' && temAgregados > 0) {
          this.btnDisabled2 = false;
        }

        const msgValidaImplemento =
          !temImplemento && configuracaoImplemento
            ? 'É necessario adicionar um Implemento'
            : '';

        if (msgValidaImplemento && temImplemento === 0) {
          this.msgValidacaoImplementoAgregado = msgValidaImplemento;
          this.validaImplementosAgregados = true;
          return false;
        }

        if (msgValidaImplemento === '' && temImplemento > 0) {
          this.btnDisabled2 = false;
        }
      }

      if (!this.form.agregado && this.form.agregados.length > 0) {
        this.form.agregados = [];
      }

      if (!this.form.implemento && this.form.implementos.length > 0) {
        this.form.implementos = [];
      }

      return true;
    },

    removeVeiculoDaLista(index) {
      this.$refs.confirmModal.showModal();
      this.indexToDelete = index;
    },

    confirmRemoveVeiculo(confimed) {
      if (
        this.indexToDelete > -1 &&
        this.indexToDelete < this.listFrotaVeiculos.length &&
        confimed
      ) {
        this.listFrotaVeiculos.splice(this.indexToDelete, 1);
        this.notifyMsg('success', 'Veículo deletado da lista');
        return;
      }
      this.notifyMsg('warning', 'Operação cancelada!');
    },

    selecionaGrupo() {
      this.form.veiculo.idGrupo = this.idGrupo.id;
      this.form.idGrupo.id = this.idGrupo.id;
    },

    onSubmit() {
      if (this.listFrotaVeiculos && this.listFrotaVeiculos.length > 1) {
        this.$emit('submitDadosVeiculos', this.listFrotaVeiculos);
        return true;
      }
      this.notifyMsg('danger', 'A lista deve conter pelo menos 2 veículos.');
      return false;
    },

    preencheDadosBeneficiario() {
      this.cloneDadosBeneficiario = deepClone(this.dadosBeneficiario);
      this.form = { ...this.form, ...this.cloneDadosBeneficiario };
      if (this.form.somenteAgregado) {
        this.ajustarPropostaParaSomenteAgregado();
      }
      this.verificaZero();
      this.listFrotaVeiculos = this.veiculosProposta;
    },

    async buscarProdutosVeiculo() {
      try {
        const { data: produtosVeiculoMultiplo } = await service.post(
          'CotacaoAberta',
          'BuscaProdutos',
          this.form,
        );

        this.foraTabela = false;
        this.buscouProdutos = true;
        if (produtosVeiculoMultiplo.length === 0) {
          this.notifyMsg('danger', 'Nenhum Produto Encontrado para essa faixa');
          return false;
        }
        let prodsOk = true;
        if (this.idTipoFipe.id !== 3) {
          this.produtos = produtosVeiculoMultiplo;
        }

        if (this.idTipoFipe.id === 3) {
          this.produtos = produtosVeiculoMultiplo.produtosVeiculo;

          if (
            produtosVeiculoMultiplo.produtosAgregados &&
            produtosVeiculoMultiplo.produtosAgregados.length > 0
          ) {
            let _agregados = produtosVeiculoMultiplo.produtosAgregados.reduce(
              (acc, item) => {
                let _produtosObrigatorios = [];
                let _produtosNaoObrigatorios = [];
                let _produtosSelecionados = [];
                item.produtos.forEach((produto) => {
                  produto.valorFinal = produto.valor;
                  produto.descontoConcedido = 0;
                  produto.id = produto.id_produto;
                  if (produto.obrigatorio) {
                    _produtosObrigatorios.push(produto);
                    _produtosSelecionados.push(produto);
                  } else {
                    _produtosNaoObrigatorios.push(produto);
                  }
                });
                const agregado = {
                  ...item,
                  produtosObrigatorios: _produtosObrigatorios,
                  produtosNaoObrigatorios: _produtosNaoObrigatorios,
                  produtosSelecionados: _produtosSelecionados,
                };
                acc.push(agregado);
                return acc;
              },
              [],
            );
            this.form.agregados = _agregados;
          }
        }

        this.produtos.forEach((produto, index) => {
          if (produto.acrescimoMensalidade === 'null') {
            produto.acrescimoMensalidade = null;
          }

          if (
            produto.acrescimoMensalidade &&
            this.form.idTipoEstacionamento === 2
          ) {
            const produtoComAcrescimo =
              produtoService.aplicaAcrescimoMensalidade(
                produto,
                this.form.estado,
              );

            this.produtos[index] = produtoComAcrescimo;
          }

          if (!produto.isComplementar) {
            produto.exibir = true;
          }

          if (produto.isComplementar) {
            produto.exibir = false;
          }
        });

        this.produtosObrigatorios = [];
        this.produtosNaoObrigatorios = [];
        this.form.produtosSelecionados = [];
        this.produtos.forEach((element) => {
          element.valorFinal = element.valor;
          element.descontoConcedido = 0;
          element.id = element.id_produto;
          if (element.obrigatorio) {
            this.produtosObrigatorios.push(element);
            this.form.produtosSelecionados.push(element);
          } else {
            this.produtosNaoObrigatorios.push(element);
          }
          if (element.valor === null) {
            prodsOk = false;
          }
        });

        this.produtosObrigatorios.sort(function (a, b) {
          return a.nomeProduto < b.nomeProduto
            ? -1
            : a.nomeProduto > b.nomeProduto
            ? 1
            : 0;
        });
        this.formInformacoes = this.form;
        this.produtosNaoObrigatorios.sort(function (a, b) {
          return a.nomeProduto < b.nomeProduto
            ? -1
            : a.nomeProduto > b.nomeProduto
            ? 1
            : 0;
        });
        if (!prodsOk) {
          this.produtos = [];
          this.foraTabela = true;
          this.notifyMsg('danger', 'Valores fora da Tabela');
          return false;
        }
        return true;
      } catch (e) {
        this.notifyMsg('danger', e);
      } finally {
        this.$vs.loading.close();
      }
    },

    abrirModalComplemento() {
      this.idGrupoVinculoAgregado = this.idGrupo.id;
      this.modalComplemento = true;
      this.resetFormComplemento = false;
    },

    editarComplemento(dadosComplemento) {
      this.agregadoSelecionado = dadosComplemento;
      this.resetFormComplemento = false;
      this.abrirModalComplemento();
    },
    adicionarComplemento(dadosComplementos) {
      const tipo = `${dadosComplementos.tipo}s`;
      this.form[tipo].push(dadosComplementos);

      this.modalComplemento = false;

      if (dadosComplementos.tipo === 'agregado')
        this.validaImplementosAgregados = false;

      if (dadosComplementos.tipo === 'implemento') {
        this.validaImplementosAgregados = false;
        this.calcularCoberturaConjunto();
      }

      this.msgValidacaoImplementoAgregado = '';
    },
    AtualizarComplemento(dadosComplemento) {
      const { index, ...dadosComplementos } = dadosComplemento;
      const tipo = `${dadosComplementos.tipo}s`;
      const itemSelecionado = `${dadosComplementos.tipo}Selecionado`;

      this.form[tipo][index] = dadosComplementos;
      this.modalComplemento = false;
      this[itemSelecionado] = {};

      this.calcularCoberturaConjunto();
    },
    excluirComplemento(dadosComplemento) {
      const { index, ...dadosComplementos } = dadosComplemento;
      const tipo = `${dadosComplementos.tipo}s`;
      const itemSelecionado = `${dadosComplementos.tipo}Selecionado`;

      this.form[tipo].splice(index, 1);
      this[itemSelecionado] = {};

      this.calcularCoberturaConjunto();
    },

    definirTituloListaComplementos(item) {
      const temPlaca = item.placa ? item.placa + ' ' : '';
      const temChassi = item.chassi ? item.chassi + ' ' : '';
      const temDescricao = item.descricao ? item.descricao + ' -' : '';
      const temValorCobertura = item.valorCobertura ? item.valorCobertura : '';
      const temValorNf = item.valorNf ? item.valorNf : '';
      const temValor = ` Valor: R$ ${temValorCobertura || temValorNf}`;

      return `${temPlaca || temChassi}${temDescricao}${temValor}`;
    },

    definirSubTituloListaComplementos(item) {
      const temMarca = item.marca ? item.marca + ' ' : '';
      const temModelo = item.modelo ? item.modelo + ' ' : '';
      const temPlacaVinculo = item.placaVinculo
        ? `| Vinculo: ${item.placaVinculo}`
        : '';
      const temChassiVinculo = item.chassiVinculo
        ? `| Vinculo: ${item.chassiVinculo}`
        : '';
      const temVinculo = temPlacaVinculo || temChassiVinculo;

      return `${temMarca}${temModelo}${temVinculo}`;
    },

    verificaChassiDuplicado(chassi) {
      if (chassi && chassi.length === 17) {
        const veiculoExiste = this.listFrotaVeiculos.find(
          (veiculo) => veiculo.chassi.toUpperCase() === chassi.toUpperCase(),
        );
        if (veiculoExiste) {
          this.notifyMsg('danger', 'Chassi já adicionado na lista de veículos');
          this.form.chassi = null;
        }
      }
    },

    verificaPlacaChassiFrota(value) {
      const dadoExiste = this.listFrotaVeiculos.find((veiculo) => {
        if (value && value.length === 8)
          return veiculo.placa.toUpperCase() === value.toUpperCase();
      });
      return dadoExiste;
    },
    async classeIsTrue() {
      const decoded = jwt.decode(localStorage.getItem('user-token'));
      const idEmpresa = decoded.id_empresa;
      const { data } = await service.getAll(
        'g',
        {},
        'empresas/list/idEmpresa/' + idEmpresa,
      );
      const _data = decryptData(data);
      this.isClasse = _data[0].classe;
    },
    async buscaClasses() {
      const classes = await service.getAll(
        `${this.controllerClasse}`,
        {},
        `obterClasses/1/10000/true`,
      );

      this.classes = classes.data.classes.map((classe) => ({
        id: classe.idClasse,
        label: classe.nome,
      }));
    },
    async selecionaClasse() {
      this.$vs.loading();
      await this.buscaDadosGrupos();
      const subTipoSelecionado = this.classe.id;
      const gruposClasse = await service.getAll(
        `${this.controllerClasse}`,
        {},
        `busca-grupo-classe/${subTipoSelecionado}`,
      );
      this.gruposPorClasse = gruposClasse.data.gruposClasse;
      const objGruposClone = deepClone(this.grupos);
      const gruposComMesmoId = objGruposClone.filter((obj) => {
        return this.gruposPorClasse.some((grupo) => grupo.idGrupo === obj.id);
      });
      if (gruposComMesmoId && gruposComMesmoId.length > 0) {
        this.grupos = gruposComMesmoId;
      } else {
        if (this.form.somenteAgregado) {
          this.grupos = [];
          this.idGrupo = {};
          this.habilitaAlterarGrupo = false;

          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Nenhum grupo vinculado a essa Classe',
            color: 'danger',
            timer: 5000,
          });
          this.$vs.loading.close();

          return;
        }
        this.grupos = [];
        this.idGrupo = null;
        this.habilitaAlterarGrupo = false;

        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Nenhum grupo vinculado a essa Classe',
          color: 'danger',
          timer: 5000,
        });
        this.$vs.loading.close();
      }
      if (this.form.somenteAgregado) {
        const apenasUmGrupoSelecionado =
          this.grupos && this.grupos.length === 1;
        if (apenasUmGrupoSelecionado) {
          this.idGrupo = this.grupos;
          this.abrirModalGrupos();
          this.$vs.loading.close();

          return;
        }
        this.abrirModalGrupos();
        this.habilitaAlterarGrupo = true;
      }
      const apenasUmGrupoSelecionado = this.grupos && this.grupos.length === 1;
      if (apenasUmGrupoSelecionado) {
        this.idGrupo = this.grupos[0];
        this.$vs.loading.close();
      }
      this.radioSelecionado = null;
      this.idGrupo = [];
      this.inputClasseIsTrue = true;
      this.$vs.loading.close();
    },
    async ajustarPropostaParaSomenteAgregado() {
      const propostaParaSomenteAgregado = this.form.somenteAgregado;
      this.idGrupo = { id: null, label: '' };

      this.idTipoFipeAux = propostaParaSomenteAgregado
        ? { id: 3, label: 'Caminhão' }
        : { id: null, label: 'Selecione' };

      this.idTipoFipe = this.idTipoFipeAux;

      this.form.veiculo.tipoVeiculo = propostaParaSomenteAgregado
        ? this.idTipoFipe.id
        : null;

      if (!this.idTipoFipe) this.idTipoFipe = this.idTipoFipe;

      if (propostaParaSomenteAgregado) {
        this.grupos = [];
        await this.buscaDadosGrupos();
      }

      this.permitirSomenteAgregado = propostaParaSomenteAgregado;

      this.habilitaAlterarGrupo = !propostaParaSomenteAgregado;
      const agregadoUnicoGrupo =
        this.grupos.length === 1 && propostaParaSomenteAgregado;
      const agregadoMultiplosGrupos =
        this.grupos.length > 1 && propostaParaSomenteAgregado;

      if (agregadoMultiplosGrupos) {
        this.idGrupo = {};
        this.habilitaAlterarGrupo = false;
      }

      if (agregadoUnicoGrupo) {
        this.mostrarModalGrupos = false;
        this.habilitaAlterarGrupo = true;
        this.idGrupo = this.grupos[0];
      }
    },

    async buscaDadosEmpresa() {
      try {
        this.$vs.loading();
        const token = localStorage.getItem('user-token');
        const decoded = jwt.decode(token);
        this.form.idEmpresa = decoded.id_empresa;
        const { data } = await service.getAll(
          'g',
          {},
          `empresas/list/idEmpresa/${this.form.idEmpresa}`,
        );

        const _data = decryptData(data);
        const [resultEmpresa] = _data;

        const ativaMascara = resultEmpresa.ativaMascarasVeiculos;

        if (ativaMascara) {
          (this.mascaraCarro = resultEmpresa.mascaraCarro),
            (this.mascaraMoto = resultEmpresa.mascaraMoto),
            (this.mascaraCaminhao = resultEmpresa.mascaraCaminhao),
            (this.mascaraAgregado = resultEmpresa.mascaraAgregado),
            (this.mascaraImplemento = resultEmpresa.mascaraImplemento);
          this.ativaMascarasVeiculos = resultEmpresa.ativaMascarasVeiculos;
        }

        this.exigirCampoEstacionamentoProposta =
          resultEmpresa.exigirCampoEstacionamentoProposta;

        this.calcularDiasUteisNfVistoria =
          resultEmpresa.calcularDiasUteisNfVistoria;
        this.calcularDiasUteisNfVistoria =
          resultEmpresa.calcularDiasUteisNfVistoria;
        this.diasZeroKM = resultEmpresa.diasZeroKM;
      } catch (error) {
        this.erroConexao =
          'Seu aplicativo parece estar offline, verifique sua conexão';
        throw error;
      } finally {
        this.$vs.loading.close();
      }
    },
    popupTitle() {
      if (this.ativaMascarasVeiculos) {
        if (this.tipoConfiguracaoCaminhao === 'agregado') {
          return this.mascaraAgregado;
        }
        if (this.tipoConfiguracaoCaminhao === 'implemento') {
          return this.mascaraImplemento;
        }
      }
      return this.tipoConfiguracaoCaminhao;
    },
    async getMarcaAgregadoImplemento() {
      try {
        this.$vs.loading();

        const marcas = await service.getAll(
          'Cotacao',
          {},
          'get-marca-agregado-implemento',
        );

        this.marcaAgregadoImplemento = marcas.data.map((marca) => ({
          value: marca.idMarcaAgregadoImplemento,
          label: marca.nome,
        }));
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `'Erro ao buscar marcas de agregado e implemento`,
          color: 'danger',
          time: 3000,
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async getModeloAgregadoImplemento(marcaId) {
      try {
        this.$vs.loading();

        const modelos = await service.getAll(
          'Cotacao',
          {},
          `get-modelo-agregado-implemento/${marcaId}`,
        );

        this.modeloAgregadoImplemento = modelos.data.map((marca) => ({
          value: marca.idModeloAgregadoImplemento,
          label: marca.nome,
        }));
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `'Erro ao buscar modelos de agregado e implemento`,
          color: 'danger',
          time: 3000,
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },

  async created() {
    this.preencheDadosBeneficiario();
    await this.buscaDadosEmpresa();
    await this.buscaDadosTipos();
  },

  mounted() {
    this.preencheSelects();
    this.buscaClasses();
    this.classeIsTrue();
    this.buscaDadosEmpresa();
    this.getMarcaAgregadoImplemento();
  },
};
</script>

<style scoped>
.formVehicle {
  border: 1px solid #cdcdcd;
}
</style>

<style>
.formVehicle .vs-button .vs-icon {
  font-size: 1.5rem;
}
.striped {
  border-radius: 7px;
  background-color: #f7fbfd;
}
</style>
